import __pb_dep_0 from "google-protobuf";
import __pb_dep_1 from "./IM.BaseDefine_pb.js";

const __pbDeps = {
  "google-protobuf": __pb_dep_0,
  "./IM.BaseDefine_pb.js": __pb_dep_1,
};

const __pbModule = { exports: {} };
const exports = __pbModule.exports;
const module = __pbModule;

const require = (specifier) => {
  const resolved = __pbDeps[specifier];
  if (!resolved) {
    throw new Error(`Unsupported protobuf dependency in IM.Call_pb.js: ${specifier}`);
  }
  return resolved;
};

(function runGeneratedProtobufModule() {
  const root = globalThis;
  root.proto ??= {};
  var proto = root.proto;
  var COMPILED = false;

// source: IM.Call.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck
var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();
var IM_BaseDefine_pb = require('./IM.BaseDefine_pb.js');
goog.object.extend(proto, IM_BaseDefine_pb);
goog.exportSymbol('proto.IM.Call.CallCommandQuery', null, global);
goog.exportSymbol('proto.IM.Call.CallCommandType', null, global);
goog.exportSymbol('proto.IM.Call.CallCreateCommand', null, global);
goog.exportSymbol('proto.IM.Call.CallLifecycleResult', null, global);
goog.exportSymbol('proto.IM.Call.CallLifecycleState', null, global);
goog.exportSymbol('proto.IM.Call.CallMediaKind', null, global);
goog.exportSymbol('proto.IM.Call.CallMessageContent', null, global);
goog.exportSymbol('proto.IM.Call.CallOwnershipCommand', null, global);
goog.exportSymbol('proto.IM.Call.CallParticipantOutcome', null, global);
goog.exportSymbol('proto.IM.Call.CallParticipantReport', null, global);
goog.exportSymbol('proto.IM.Call.CallParticipantReportResult', null, global);
goog.exportSymbol('proto.IM.Call.CallParticipantReportType', null, global);
goog.exportSymbol('proto.IM.Call.CallParticipantRole', null, global);
goog.exportSymbol('proto.IM.Call.CallParticipantTerminalSnapshot', null, global);
goog.exportSymbol('proto.IM.Call.CallProjectionKind', null, global);
goog.exportSymbol('proto.IM.Call.CallProviderEventType', null, global);
goog.exportSymbol('proto.IM.Call.CallProviderFact', null, global);
goog.exportSymbol('proto.IM.Call.CallResultCode', null, global);
goog.exportSymbol('proto.IM.Call.CallScope', null, global);
goog.exportSymbol('proto.IM.Call.CallSessionCapabilityClaims', null, global);
goog.exportSymbol('proto.IM.Call.CallSignalingOperation', null, global);
goog.exportSymbol('proto.IM.Call.CallTerminalFact', null, global);
goog.exportSymbol('proto.IM.Call.CallTerminalOutcome', null, global);
goog.exportSymbol('proto.IM.Call.GroupAttendanceLegStatus', null, global);
goog.exportSymbol('proto.IM.Call.GroupAttendanceResult', null, global);
goog.exportSymbol('proto.IM.Call.GroupCallCreateCommand', null, global);
goog.exportSymbol('proto.IM.Call.GroupCallOwnershipCommand', null, global);
goog.exportSymbol('proto.IM.Call.GroupMediaCapabilityClaims', null, global);
goog.exportSymbol('proto.IM.Call.IMCallProjectionReq', null, global);
goog.exportSymbol('proto.IM.Call.IMCallProjectionRsp', null, global);
goog.exportSymbol('proto.IM.Call.SignedCallSessionCapability', null, global);
goog.exportSymbol('proto.IM.Call.SignedGroupMediaCapability', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.CallCreateCommand = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.CallCreateCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.CallCreateCommand.displayName = 'proto.IM.Call.CallCreateCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.GroupCallCreateCommand = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.GroupCallCreateCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.GroupCallCreateCommand.displayName = 'proto.IM.Call.GroupCallCreateCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.GroupCallOwnershipCommand = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.GroupCallOwnershipCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.GroupCallOwnershipCommand.displayName = 'proto.IM.Call.GroupCallOwnershipCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.GroupAttendanceResult = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.GroupAttendanceResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.GroupAttendanceResult.displayName = 'proto.IM.Call.GroupAttendanceResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.GroupMediaCapabilityClaims = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.GroupMediaCapabilityClaims, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.GroupMediaCapabilityClaims.displayName = 'proto.IM.Call.GroupMediaCapabilityClaims';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.SignedGroupMediaCapability = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.SignedGroupMediaCapability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.SignedGroupMediaCapability.displayName = 'proto.IM.Call.SignedGroupMediaCapability';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.CallProviderFact = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.CallProviderFact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.CallProviderFact.displayName = 'proto.IM.Call.CallProviderFact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.CallOwnershipCommand = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.CallOwnershipCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.CallOwnershipCommand.displayName = 'proto.IM.Call.CallOwnershipCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.CallCommandQuery = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.CallCommandQuery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.CallCommandQuery.displayName = 'proto.IM.Call.CallCommandQuery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.CallParticipantReport = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.CallParticipantReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.CallParticipantReport.displayName = 'proto.IM.Call.CallParticipantReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.CallParticipantReportResult = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.CallParticipantReportResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.CallParticipantReportResult.displayName = 'proto.IM.Call.CallParticipantReportResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.CallSessionCapabilityClaims = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, proto.IM.Call.CallSessionCapabilityClaims.repeatedFields_, null);
};
goog.inherits(proto.IM.Call.CallSessionCapabilityClaims, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.CallSessionCapabilityClaims.displayName = 'proto.IM.Call.CallSessionCapabilityClaims';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.SignedCallSessionCapability = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.SignedCallSessionCapability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.SignedCallSessionCapability.displayName = 'proto.IM.Call.SignedCallSessionCapability';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.CallLifecycleResult = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.CallLifecycleResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.CallLifecycleResult.displayName = 'proto.IM.Call.CallLifecycleResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.CallParticipantTerminalSnapshot = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.CallParticipantTerminalSnapshot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.CallParticipantTerminalSnapshot.displayName = 'proto.IM.Call.CallParticipantTerminalSnapshot';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.CallTerminalFact = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, proto.IM.Call.CallTerminalFact.repeatedFields_, null);
};
goog.inherits(proto.IM.Call.CallTerminalFact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.CallTerminalFact.displayName = 'proto.IM.Call.CallTerminalFact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.CallMessageContent = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, proto.IM.Call.CallMessageContent.repeatedFields_, null);
};
goog.inherits(proto.IM.Call.CallMessageContent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.CallMessageContent.displayName = 'proto.IM.Call.CallMessageContent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.IMCallProjectionReq = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.IMCallProjectionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.IMCallProjectionReq.displayName = 'proto.IM.Call.IMCallProjectionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Call.IMCallProjectionRsp = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Call.IMCallProjectionRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Call.IMCallProjectionRsp.displayName = 'proto.IM.Call.IMCallProjectionRsp';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.CallCreateCommand.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.CallCreateCommand.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.CallCreateCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallCreateCommand.toObject = function(includeInstance, msg) {
        var f, obj = {
            commandId: msg.getCommandId_asB64(),
            actorUserId: jspb.Message.getFieldWithDefault(msg, 2, 0),
            peerUserId: jspb.Message.getFieldWithDefault(msg, 3, 0),
            mediaKind: jspb.Message.getFieldWithDefault(msg, 4, 0),
            opaqueDeviceRefHash: msg.getOpaqueDeviceRefHash_asB64(),
            requestedAtMs: jspb.Message.getFieldWithDefault(msg, 6, 0),
            nonce: msg.getNonce_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.CallCreateCommand}
 */ proto.IM.Call.CallCreateCommand.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.CallCreateCommand;
    return proto.IM.Call.CallCreateCommand.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.CallCreateCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.CallCreateCommand}
 */ proto.IM.Call.CallCreateCommand.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCommandId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setActorUserId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setPeerUserId(value);
                break;
            case 4:
                var value = /** @type {!proto.IM.Call.CallMediaKind} */ reader.readEnum();
                msg.setMediaKind(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setOpaqueDeviceRefHash(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint64();
                msg.setRequestedAtMs(value);
                break;
            case 7:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setNonce(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.CallCreateCommand.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.CallCreateCommand.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.CallCreateCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallCreateCommand.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCommandId_asU8();
    if (f.length > 0) {
        writer.writeBytes(1, f);
    }
    f = message.getActorUserId();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = message.getPeerUserId();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
    f = message.getMediaKind();
    if (f !== 0.0) {
        writer.writeEnum(4, f);
    }
    f = message.getOpaqueDeviceRefHash_asU8();
    if (f.length > 0) {
        writer.writeBytes(5, f);
    }
    f = message.getRequestedAtMs();
    if (f !== 0) {
        writer.writeUint64(6, f);
    }
    f = message.getNonce_asU8();
    if (f.length > 0) {
        writer.writeBytes(7, f);
    }
};
/**
 * optional bytes command_id = 1;
 * @return {string}
 */ proto.IM.Call.CallCreateCommand.prototype.getCommandId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes command_id = 1;
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {string}
 */ proto.IM.Call.CallCreateCommand.prototype.getCommandId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCommandId());
};
/**
 * optional bytes command_id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallCreateCommand.prototype.getCommandId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCommandId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallCreateCommand} returns this
 */ proto.IM.Call.CallCreateCommand.prototype.setCommandId = function(value) {
    return jspb.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional uint32 actor_user_id = 2;
 * @return {number}
 */ proto.IM.Call.CallCreateCommand.prototype.getActorUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallCreateCommand} returns this
 */ proto.IM.Call.CallCreateCommand.prototype.setActorUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional uint32 peer_user_id = 3;
 * @return {number}
 */ proto.IM.Call.CallCreateCommand.prototype.getPeerUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallCreateCommand} returns this
 */ proto.IM.Call.CallCreateCommand.prototype.setPeerUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional CallMediaKind media_kind = 4;
 * @return {!proto.IM.Call.CallMediaKind}
 */ proto.IM.Call.CallCreateCommand.prototype.getMediaKind = function() {
    return /** @type {!proto.IM.Call.CallMediaKind} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.IM.Call.CallMediaKind} value
 * @return {!proto.IM.Call.CallCreateCommand} returns this
 */ proto.IM.Call.CallCreateCommand.prototype.setMediaKind = function(value) {
    return jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional bytes opaque_device_ref_hash = 5;
 * @return {string}
 */ proto.IM.Call.CallCreateCommand.prototype.getOpaqueDeviceRefHash = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes opaque_device_ref_hash = 5;
 * This is a type-conversion wrapper around `getOpaqueDeviceRefHash()`
 * @return {string}
 */ proto.IM.Call.CallCreateCommand.prototype.getOpaqueDeviceRefHash_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getOpaqueDeviceRefHash());
};
/**
 * optional bytes opaque_device_ref_hash = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOpaqueDeviceRefHash()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallCreateCommand.prototype.getOpaqueDeviceRefHash_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getOpaqueDeviceRefHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallCreateCommand} returns this
 */ proto.IM.Call.CallCreateCommand.prototype.setOpaqueDeviceRefHash = function(value) {
    return jspb.Message.setProto3BytesField(this, 5, value);
};
/**
 * optional uint64 requested_at_ms = 6;
 * @return {number}
 */ proto.IM.Call.CallCreateCommand.prototype.getRequestedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallCreateCommand} returns this
 */ proto.IM.Call.CallCreateCommand.prototype.setRequestedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional bytes nonce = 7;
 * @return {string}
 */ proto.IM.Call.CallCreateCommand.prototype.getNonce = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 7, "");
};
/**
 * optional bytes nonce = 7;
 * This is a type-conversion wrapper around `getNonce()`
 * @return {string}
 */ proto.IM.Call.CallCreateCommand.prototype.getNonce_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getNonce());
};
/**
 * optional bytes nonce = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getNonce()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallCreateCommand.prototype.getNonce_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getNonce());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallCreateCommand} returns this
 */ proto.IM.Call.CallCreateCommand.prototype.setNonce = function(value) {
    return jspb.Message.setProto3BytesField(this, 7, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.GroupCallCreateCommand.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.GroupCallCreateCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.GroupCallCreateCommand.toObject = function(includeInstance, msg) {
        var f, obj = {
            commandId: msg.getCommandId_asB64(),
            actorUserId: jspb.Message.getFieldWithDefault(msg, 2, 0),
            groupId: jspb.Message.getFieldWithDefault(msg, 3, 0),
            mediaKind: jspb.Message.getFieldWithDefault(msg, 4, 0),
            opaqueDeviceRefHash: msg.getOpaqueDeviceRefHash_asB64(),
            requestedAtMs: jspb.Message.getFieldWithDefault(msg, 6, 0),
            nonce: msg.getNonce_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.GroupCallCreateCommand}
 */ proto.IM.Call.GroupCallCreateCommand.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.GroupCallCreateCommand;
    return proto.IM.Call.GroupCallCreateCommand.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.GroupCallCreateCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.GroupCallCreateCommand}
 */ proto.IM.Call.GroupCallCreateCommand.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCommandId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setActorUserId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setGroupId(value);
                break;
            case 4:
                var value = /** @type {!proto.IM.Call.CallMediaKind} */ reader.readEnum();
                msg.setMediaKind(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setOpaqueDeviceRefHash(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint64();
                msg.setRequestedAtMs(value);
                break;
            case 7:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setNonce(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.GroupCallCreateCommand.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.GroupCallCreateCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.GroupCallCreateCommand.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCommandId_asU8();
    if (f.length > 0) {
        writer.writeBytes(1, f);
    }
    f = message.getActorUserId();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = message.getGroupId();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
    f = message.getMediaKind();
    if (f !== 0.0) {
        writer.writeEnum(4, f);
    }
    f = message.getOpaqueDeviceRefHash_asU8();
    if (f.length > 0) {
        writer.writeBytes(5, f);
    }
    f = message.getRequestedAtMs();
    if (f !== 0) {
        writer.writeUint64(6, f);
    }
    f = message.getNonce_asU8();
    if (f.length > 0) {
        writer.writeBytes(7, f);
    }
};
/**
 * optional bytes command_id = 1;
 * @return {string}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getCommandId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes command_id = 1;
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {string}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getCommandId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCommandId());
};
/**
 * optional bytes command_id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getCommandId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCommandId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupCallCreateCommand} returns this
 */ proto.IM.Call.GroupCallCreateCommand.prototype.setCommandId = function(value) {
    return jspb.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional uint32 actor_user_id = 2;
 * @return {number}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getActorUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupCallCreateCommand} returns this
 */ proto.IM.Call.GroupCallCreateCommand.prototype.setActorUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional uint32 group_id = 3;
 * @return {number}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getGroupId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupCallCreateCommand} returns this
 */ proto.IM.Call.GroupCallCreateCommand.prototype.setGroupId = function(value) {
    return jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional CallMediaKind media_kind = 4;
 * @return {!proto.IM.Call.CallMediaKind}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getMediaKind = function() {
    return /** @type {!proto.IM.Call.CallMediaKind} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.IM.Call.CallMediaKind} value
 * @return {!proto.IM.Call.GroupCallCreateCommand} returns this
 */ proto.IM.Call.GroupCallCreateCommand.prototype.setMediaKind = function(value) {
    return jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional bytes opaque_device_ref_hash = 5;
 * @return {string}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getOpaqueDeviceRefHash = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes opaque_device_ref_hash = 5;
 * This is a type-conversion wrapper around `getOpaqueDeviceRefHash()`
 * @return {string}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getOpaqueDeviceRefHash_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getOpaqueDeviceRefHash());
};
/**
 * optional bytes opaque_device_ref_hash = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOpaqueDeviceRefHash()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getOpaqueDeviceRefHash_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getOpaqueDeviceRefHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupCallCreateCommand} returns this
 */ proto.IM.Call.GroupCallCreateCommand.prototype.setOpaqueDeviceRefHash = function(value) {
    return jspb.Message.setProto3BytesField(this, 5, value);
};
/**
 * optional uint64 requested_at_ms = 6;
 * @return {number}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getRequestedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupCallCreateCommand} returns this
 */ proto.IM.Call.GroupCallCreateCommand.prototype.setRequestedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional bytes nonce = 7;
 * @return {string}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getNonce = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 7, "");
};
/**
 * optional bytes nonce = 7;
 * This is a type-conversion wrapper around `getNonce()`
 * @return {string}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getNonce_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getNonce());
};
/**
 * optional bytes nonce = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getNonce()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupCallCreateCommand.prototype.getNonce_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getNonce());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupCallCreateCommand} returns this
 */ proto.IM.Call.GroupCallCreateCommand.prototype.setNonce = function(value) {
    return jspb.Message.setProto3BytesField(this, 7, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.GroupCallOwnershipCommand.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.GroupCallOwnershipCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.GroupCallOwnershipCommand.toObject = function(includeInstance, msg) {
        var f, obj = {
            commandId: msg.getCommandId_asB64(),
            commandType: jspb.Message.getFieldWithDefault(msg, 2, 0),
            callId: msg.getCallId_asB64(),
            sessionId: msg.getSessionId_asB64(),
            actorUserId: jspb.Message.getFieldWithDefault(msg, 5, 0),
            targetUserId: jspb.Message.getFieldWithDefault(msg, 6, 0),
            opaqueDeviceRefHash: msg.getOpaqueDeviceRefHash_asB64(),
            currentLegId: msg.getCurrentLegId_asB64(),
            expectedVersion: jspb.Message.getFieldWithDefault(msg, 9, 0),
            fence: jspb.Message.getFieldWithDefault(msg, 10, 0),
            requestedAtMs: jspb.Message.getFieldWithDefault(msg, 11, 0),
            nonce: msg.getNonce_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.GroupCallOwnershipCommand}
 */ proto.IM.Call.GroupCallOwnershipCommand.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.GroupCallOwnershipCommand;
    return proto.IM.Call.GroupCallOwnershipCommand.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.GroupCallOwnershipCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.GroupCallOwnershipCommand}
 */ proto.IM.Call.GroupCallOwnershipCommand.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCommandId(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.Call.CallCommandType} */ reader.readEnum();
                msg.setCommandType(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCallId(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSessionId(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setActorUserId(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint32();
                msg.setTargetUserId(value);
                break;
            case 7:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setOpaqueDeviceRefHash(value);
                break;
            case 8:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCurrentLegId(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readUint64();
                msg.setExpectedVersion(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readUint64();
                msg.setFence(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readUint64();
                msg.setRequestedAtMs(value);
                break;
            case 12:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setNonce(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.GroupCallOwnershipCommand.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.GroupCallOwnershipCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.GroupCallOwnershipCommand.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCommandId_asU8();
    if (f.length > 0) {
        writer.writeBytes(1, f);
    }
    f = message.getCommandType();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
    f = message.getCallId_asU8();
    if (f.length > 0) {
        writer.writeBytes(3, f);
    }
    f = message.getSessionId_asU8();
    if (f.length > 0) {
        writer.writeBytes(4, f);
    }
    f = message.getActorUserId();
    if (f !== 0) {
        writer.writeUint32(5, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 6);
    if (f != null) {
        writer.writeUint32(6, f);
    }
    f = message.getOpaqueDeviceRefHash_asU8();
    if (f.length > 0) {
        writer.writeBytes(7, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 8);
    if (f != null) {
        writer.writeBytes(8, f);
    }
    f = message.getExpectedVersion();
    if (f !== 0) {
        writer.writeUint64(9, f);
    }
    f = message.getFence();
    if (f !== 0) {
        writer.writeUint64(10, f);
    }
    f = message.getRequestedAtMs();
    if (f !== 0) {
        writer.writeUint64(11, f);
    }
    f = message.getNonce_asU8();
    if (f.length > 0) {
        writer.writeBytes(12, f);
    }
};
/**
 * optional bytes command_id = 1;
 * @return {string}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getCommandId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes command_id = 1;
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {string}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getCommandId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCommandId());
};
/**
 * optional bytes command_id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getCommandId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCommandId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.setCommandId = function(value) {
    return jspb.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional CallCommandType command_type = 2;
 * @return {!proto.IM.Call.CallCommandType}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getCommandType = function() {
    return /** @type {!proto.IM.Call.CallCommandType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.Call.CallCommandType} value
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.setCommandType = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional bytes call_id = 3;
 * @return {string}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getCallId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes call_id = 3;
 * This is a type-conversion wrapper around `getCallId()`
 * @return {string}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getCallId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCallId());
};
/**
 * optional bytes call_id = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getCallId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCallId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.setCallId = function(value) {
    return jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional bytes session_id = 4;
 * @return {string}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getSessionId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes session_id = 4;
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {string}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getSessionId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSessionId());
};
/**
 * optional bytes session_id = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getSessionId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSessionId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3BytesField(this, 4, value);
};
/**
 * optional uint32 actor_user_id = 5;
 * @return {number}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getActorUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.setActorUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional uint32 target_user_id = 6;
 * @return {number}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getTargetUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.setTargetUserId = function(value) {
    return jspb.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.clearTargetUserId = function() {
    return jspb.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.hasTargetUserId = function() {
    return jspb.Message.getField(this, 6) != null;
};
/**
 * optional bytes opaque_device_ref_hash = 7;
 * @return {string}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getOpaqueDeviceRefHash = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 7, "");
};
/**
 * optional bytes opaque_device_ref_hash = 7;
 * This is a type-conversion wrapper around `getOpaqueDeviceRefHash()`
 * @return {string}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getOpaqueDeviceRefHash_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getOpaqueDeviceRefHash());
};
/**
 * optional bytes opaque_device_ref_hash = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOpaqueDeviceRefHash()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getOpaqueDeviceRefHash_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getOpaqueDeviceRefHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.setOpaqueDeviceRefHash = function(value) {
    return jspb.Message.setProto3BytesField(this, 7, value);
};
/**
 * optional bytes current_leg_id = 8;
 * @return {string}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getCurrentLegId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 8, "");
};
/**
 * optional bytes current_leg_id = 8;
 * This is a type-conversion wrapper around `getCurrentLegId()`
 * @return {string}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getCurrentLegId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCurrentLegId());
};
/**
 * optional bytes current_leg_id = 8;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCurrentLegId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getCurrentLegId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCurrentLegId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.setCurrentLegId = function(value) {
    return jspb.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.clearCurrentLegId = function() {
    return jspb.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.hasCurrentLegId = function() {
    return jspb.Message.getField(this, 8) != null;
};
/**
 * optional uint64 expected_version = 9;
 * @return {number}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getExpectedVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.setExpectedVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 9, value);
};
/**
 * optional uint64 fence = 10;
 * @return {number}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getFence = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.setFence = function(value) {
    return jspb.Message.setProto3IntField(this, 10, value);
};
/**
 * optional uint64 requested_at_ms = 11;
 * @return {number}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getRequestedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.setRequestedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 11, value);
};
/**
 * optional bytes nonce = 12;
 * @return {string}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getNonce = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 12, "");
};
/**
 * optional bytes nonce = 12;
 * This is a type-conversion wrapper around `getNonce()`
 * @return {string}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getNonce_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getNonce());
};
/**
 * optional bytes nonce = 12;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getNonce()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.getNonce_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getNonce());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupCallOwnershipCommand} returns this
 */ proto.IM.Call.GroupCallOwnershipCommand.prototype.setNonce = function(value) {
    return jspb.Message.setProto3BytesField(this, 12, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.GroupAttendanceResult.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.GroupAttendanceResult.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.GroupAttendanceResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.GroupAttendanceResult.toObject = function(includeInstance, msg) {
        var f, obj = {
            resultCode: jspb.Message.getFieldWithDefault(msg, 1, 0),
            commandId: msg.getCommandId_asB64(),
            callId: msg.getCallId_asB64(),
            sessionId: msg.getSessionId_asB64(),
            attendanceLegId: msg.getAttendanceLegId_asB64(),
            actorUserId: jspb.Message.getFieldWithDefault(msg, 6, 0),
            aggregateVersion: jspb.Message.getFieldWithDefault(msg, 7, 0),
            fence: jspb.Message.getFieldWithDefault(msg, 8, 0),
            mediaCapability: (f = msg.getMediaCapability()) && proto.IM.Call.SignedGroupMediaCapability.toObject(includeInstance, f),
            committedAtMs: jspb.Message.getFieldWithDefault(msg, 10, 0),
            detailCode: jspb.Message.getFieldWithDefault(msg, 11, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.GroupAttendanceResult}
 */ proto.IM.Call.GroupAttendanceResult.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.GroupAttendanceResult;
    return proto.IM.Call.GroupAttendanceResult.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.GroupAttendanceResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.GroupAttendanceResult}
 */ proto.IM.Call.GroupAttendanceResult.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.IM.Call.CallResultCode} */ reader.readEnum();
                msg.setResultCode(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCommandId(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCallId(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSessionId(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttendanceLegId(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint32();
                msg.setActorUserId(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readUint64();
                msg.setAggregateVersion(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint64();
                msg.setFence(value);
                break;
            case 9:
                var value = new proto.IM.Call.SignedGroupMediaCapability;
                reader.readMessage(value, proto.IM.Call.SignedGroupMediaCapability.deserializeBinaryFromReader);
                msg.setMediaCapability(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readUint64();
                msg.setCommittedAtMs(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setDetailCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupAttendanceResult.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.GroupAttendanceResult.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.GroupAttendanceResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.GroupAttendanceResult.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getResultCode();
    if (f !== 0.0) {
        writer.writeEnum(1, f);
    }
    f = message.getCommandId_asU8();
    if (f.length > 0) {
        writer.writeBytes(2, f);
    }
    f = message.getCallId_asU8();
    if (f.length > 0) {
        writer.writeBytes(3, f);
    }
    f = message.getSessionId_asU8();
    if (f.length > 0) {
        writer.writeBytes(4, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 5);
    if (f != null) {
        writer.writeBytes(5, f);
    }
    f = message.getActorUserId();
    if (f !== 0) {
        writer.writeUint32(6, f);
    }
    f = message.getAggregateVersion();
    if (f !== 0) {
        writer.writeUint64(7, f);
    }
    f = message.getFence();
    if (f !== 0) {
        writer.writeUint64(8, f);
    }
    f = message.getMediaCapability();
    if (f != null) {
        writer.writeMessage(9, f, proto.IM.Call.SignedGroupMediaCapability.serializeBinaryToWriter);
    }
    f = message.getCommittedAtMs();
    if (f !== 0) {
        writer.writeUint64(10, f);
    }
    f = /** @type {string} */ jspb.Message.getField(message, 11);
    if (f != null) {
        writer.writeString(11, f);
    }
};
/**
 * optional CallResultCode result_code = 1;
 * @return {!proto.IM.Call.CallResultCode}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getResultCode = function() {
    return /** @type {!proto.IM.Call.CallResultCode} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.IM.Call.CallResultCode} value
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.setResultCode = function(value) {
    return jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional bytes command_id = 2;
 * @return {string}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getCommandId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes command_id = 2;
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {string}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getCommandId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCommandId());
};
/**
 * optional bytes command_id = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getCommandId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCommandId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.setCommandId = function(value) {
    return jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional bytes call_id = 3;
 * @return {string}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getCallId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes call_id = 3;
 * This is a type-conversion wrapper around `getCallId()`
 * @return {string}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getCallId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCallId());
};
/**
 * optional bytes call_id = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getCallId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCallId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.setCallId = function(value) {
    return jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional bytes session_id = 4;
 * @return {string}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getSessionId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes session_id = 4;
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {string}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getSessionId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSessionId());
};
/**
 * optional bytes session_id = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getSessionId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSessionId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3BytesField(this, 4, value);
};
/**
 * optional bytes attendance_leg_id = 5;
 * @return {string}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getAttendanceLegId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes attendance_leg_id = 5;
 * This is a type-conversion wrapper around `getAttendanceLegId()`
 * @return {string}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getAttendanceLegId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttendanceLegId());
};
/**
 * optional bytes attendance_leg_id = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttendanceLegId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getAttendanceLegId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttendanceLegId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.setAttendanceLegId = function(value) {
    return jspb.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.clearAttendanceLegId = function() {
    return jspb.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.GroupAttendanceResult.prototype.hasAttendanceLegId = function() {
    return jspb.Message.getField(this, 5) != null;
};
/**
 * optional uint32 actor_user_id = 6;
 * @return {number}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getActorUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.setActorUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional uint64 aggregate_version = 7;
 * @return {number}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getAggregateVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.setAggregateVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * optional uint64 fence = 8;
 * @return {number}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getFence = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.setFence = function(value) {
    return jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * optional SignedGroupMediaCapability media_capability = 9;
 * @return {?proto.IM.Call.SignedGroupMediaCapability}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getMediaCapability = function() {
    return /** @type{?proto.IM.Call.SignedGroupMediaCapability} */ jspb.Message.getWrapperField(this, proto.IM.Call.SignedGroupMediaCapability, 9);
};
/**
 * @param {?proto.IM.Call.SignedGroupMediaCapability|undefined} value
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
*/ proto.IM.Call.GroupAttendanceResult.prototype.setMediaCapability = function(value) {
    return jspb.Message.setWrapperField(this, 9, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.clearMediaCapability = function() {
    return this.setMediaCapability(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.GroupAttendanceResult.prototype.hasMediaCapability = function() {
    return jspb.Message.getField(this, 9) != null;
};
/**
 * optional uint64 committed_at_ms = 10;
 * @return {number}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getCommittedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.setCommittedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 10, value);
};
/**
 * optional string detail_code = 11;
 * @return {string}
 */ proto.IM.Call.GroupAttendanceResult.prototype.getDetailCode = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.setDetailCode = function(value) {
    return jspb.Message.setField(this, 11, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.GroupAttendanceResult} returns this
 */ proto.IM.Call.GroupAttendanceResult.prototype.clearDetailCode = function() {
    return jspb.Message.setField(this, 11, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.GroupAttendanceResult.prototype.hasDetailCode = function() {
    return jspb.Message.getField(this, 11) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.GroupMediaCapabilityClaims.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.GroupMediaCapabilityClaims} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.GroupMediaCapabilityClaims.toObject = function(includeInstance, msg) {
        var f, obj = {
            schemaVersion: jspb.Message.getFieldWithDefault(msg, 1, 0),
            callId: msg.getCallId_asB64(),
            sessionId: msg.getSessionId_asB64(),
            attendanceLegId: msg.getAttendanceLegId_asB64(),
            userId: jspb.Message.getFieldWithDefault(msg, 5, 0),
            opaqueDeviceRefHash: msg.getOpaqueDeviceRefHash_asB64(),
            livekitRoomName: jspb.Message.getFieldWithDefault(msg, 7, ""),
            providerIdentity: jspb.Message.getFieldWithDefault(msg, 8, ""),
            fence: jspb.Message.getFieldWithDefault(msg, 9, 0),
            issuedAtMs: jspb.Message.getFieldWithDefault(msg, 10, 0),
            expiresAtMs: jspb.Message.getFieldWithDefault(msg, 11, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims}
 */ proto.IM.Call.GroupMediaCapabilityClaims.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.GroupMediaCapabilityClaims;
    return proto.IM.Call.GroupMediaCapabilityClaims.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.GroupMediaCapabilityClaims} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims}
 */ proto.IM.Call.GroupMediaCapabilityClaims.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSchemaVersion(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCallId(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSessionId(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttendanceLegId(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 6:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setOpaqueDeviceRefHash(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setLivekitRoomName(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setProviderIdentity(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readUint64();
                msg.setFence(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readUint64();
                msg.setIssuedAtMs(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readUint64();
                msg.setExpiresAtMs(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.GroupMediaCapabilityClaims.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.GroupMediaCapabilityClaims} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.GroupMediaCapabilityClaims.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSchemaVersion();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getCallId_asU8();
    if (f.length > 0) {
        writer.writeBytes(2, f);
    }
    f = message.getSessionId_asU8();
    if (f.length > 0) {
        writer.writeBytes(3, f);
    }
    f = message.getAttendanceLegId_asU8();
    if (f.length > 0) {
        writer.writeBytes(4, f);
    }
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(5, f);
    }
    f = message.getOpaqueDeviceRefHash_asU8();
    if (f.length > 0) {
        writer.writeBytes(6, f);
    }
    f = message.getLivekitRoomName();
    if (f.length > 0) {
        writer.writeString(7, f);
    }
    f = message.getProviderIdentity();
    if (f.length > 0) {
        writer.writeString(8, f);
    }
    f = message.getFence();
    if (f !== 0) {
        writer.writeUint64(9, f);
    }
    f = message.getIssuedAtMs();
    if (f !== 0) {
        writer.writeUint64(10, f);
    }
    f = message.getExpiresAtMs();
    if (f !== 0) {
        writer.writeUint64(11, f);
    }
};
/**
 * optional uint32 schema_version = 1;
 * @return {number}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getSchemaVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims} returns this
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.setSchemaVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional bytes call_id = 2;
 * @return {string}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getCallId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes call_id = 2;
 * This is a type-conversion wrapper around `getCallId()`
 * @return {string}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getCallId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCallId());
};
/**
 * optional bytes call_id = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getCallId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCallId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims} returns this
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.setCallId = function(value) {
    return jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional bytes session_id = 3;
 * @return {string}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getSessionId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes session_id = 3;
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {string}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getSessionId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSessionId());
};
/**
 * optional bytes session_id = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getSessionId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSessionId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims} returns this
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional bytes attendance_leg_id = 4;
 * @return {string}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getAttendanceLegId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes attendance_leg_id = 4;
 * This is a type-conversion wrapper around `getAttendanceLegId()`
 * @return {string}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getAttendanceLegId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttendanceLegId());
};
/**
 * optional bytes attendance_leg_id = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttendanceLegId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getAttendanceLegId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttendanceLegId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims} returns this
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.setAttendanceLegId = function(value) {
    return jspb.Message.setProto3BytesField(this, 4, value);
};
/**
 * optional uint32 user_id = 5;
 * @return {number}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims} returns this
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional bytes opaque_device_ref_hash = 6;
 * @return {string}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getOpaqueDeviceRefHash = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 6, "");
};
/**
 * optional bytes opaque_device_ref_hash = 6;
 * This is a type-conversion wrapper around `getOpaqueDeviceRefHash()`
 * @return {string}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getOpaqueDeviceRefHash_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getOpaqueDeviceRefHash());
};
/**
 * optional bytes opaque_device_ref_hash = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOpaqueDeviceRefHash()`
 * @return {!Uint8Array}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getOpaqueDeviceRefHash_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getOpaqueDeviceRefHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims} returns this
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.setOpaqueDeviceRefHash = function(value) {
    return jspb.Message.setProto3BytesField(this, 6, value);
};
/**
 * optional string livekit_room_name = 7;
 * @return {string}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getLivekitRoomName = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims} returns this
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.setLivekitRoomName = function(value) {
    return jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string provider_identity = 8;
 * @return {string}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getProviderIdentity = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims} returns this
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.setProviderIdentity = function(value) {
    return jspb.Message.setProto3StringField(this, 8, value);
};
/**
 * optional uint64 fence = 9;
 * @return {number}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getFence = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims} returns this
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.setFence = function(value) {
    return jspb.Message.setProto3IntField(this, 9, value);
};
/**
 * optional uint64 issued_at_ms = 10;
 * @return {number}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getIssuedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims} returns this
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.setIssuedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 10, value);
};
/**
 * optional uint64 expires_at_ms = 11;
 * @return {number}
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.getExpiresAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.GroupMediaCapabilityClaims} returns this
 */ proto.IM.Call.GroupMediaCapabilityClaims.prototype.setExpiresAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 11, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.SignedGroupMediaCapability.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.SignedGroupMediaCapability.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.SignedGroupMediaCapability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.SignedGroupMediaCapability.toObject = function(includeInstance, msg) {
        var f, obj = {
            serializedClaims: msg.getSerializedClaims_asB64(),
            signature: msg.getSignature_asB64(),
            keyId: jspb.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.SignedGroupMediaCapability}
 */ proto.IM.Call.SignedGroupMediaCapability.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.SignedGroupMediaCapability;
    return proto.IM.Call.SignedGroupMediaCapability.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.SignedGroupMediaCapability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.SignedGroupMediaCapability}
 */ proto.IM.Call.SignedGroupMediaCapability.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSerializedClaims(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setKeyId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.SignedGroupMediaCapability.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.SignedGroupMediaCapability.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.SignedGroupMediaCapability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.SignedGroupMediaCapability.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSerializedClaims_asU8();
    if (f.length > 0) {
        writer.writeBytes(1, f);
    }
    f = message.getSignature_asU8();
    if (f.length > 0) {
        writer.writeBytes(2, f);
    }
    f = message.getKeyId();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
};
/**
 * optional bytes serialized_claims = 1;
 * @return {string}
 */ proto.IM.Call.SignedGroupMediaCapability.prototype.getSerializedClaims = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes serialized_claims = 1;
 * This is a type-conversion wrapper around `getSerializedClaims()`
 * @return {string}
 */ proto.IM.Call.SignedGroupMediaCapability.prototype.getSerializedClaims_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSerializedClaims());
};
/**
 * optional bytes serialized_claims = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSerializedClaims()`
 * @return {!Uint8Array}
 */ proto.IM.Call.SignedGroupMediaCapability.prototype.getSerializedClaims_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSerializedClaims());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.SignedGroupMediaCapability} returns this
 */ proto.IM.Call.SignedGroupMediaCapability.prototype.setSerializedClaims = function(value) {
    return jspb.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional bytes signature = 2;
 * @return {string}
 */ proto.IM.Call.SignedGroupMediaCapability.prototype.getSignature = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes signature = 2;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.IM.Call.SignedGroupMediaCapability.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.IM.Call.SignedGroupMediaCapability.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.SignedGroupMediaCapability} returns this
 */ proto.IM.Call.SignedGroupMediaCapability.prototype.setSignature = function(value) {
    return jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional string key_id = 3;
 * @return {string}
 */ proto.IM.Call.SignedGroupMediaCapability.prototype.getKeyId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.SignedGroupMediaCapability} returns this
 */ proto.IM.Call.SignedGroupMediaCapability.prototype.setKeyId = function(value) {
    return jspb.Message.setProto3StringField(this, 3, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.CallProviderFact.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.CallProviderFact.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.CallProviderFact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallProviderFact.toObject = function(includeInstance, msg) {
        var f, obj = {
            schemaVersion: jspb.Message.getFieldWithDefault(msg, 1, 0),
            providerEventId: jspb.Message.getFieldWithDefault(msg, 2, ""),
            eventType: jspb.Message.getFieldWithDefault(msg, 3, 0),
            callId: msg.getCallId_asB64(),
            sessionId: msg.getSessionId_asB64(),
            attendanceLegId: msg.getAttendanceLegId_asB64(),
            providerIdentity: jspb.Message.getFieldWithDefault(msg, 7, ""),
            rawBodyHash: msg.getRawBodyHash_asB64(),
            providerOccurredAtMs: jspb.Message.getFieldWithDefault(msg, 9, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.CallProviderFact}
 */ proto.IM.Call.CallProviderFact.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.CallProviderFact;
    return proto.IM.Call.CallProviderFact.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.CallProviderFact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.CallProviderFact}
 */ proto.IM.Call.CallProviderFact.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSchemaVersion(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setProviderEventId(value);
                break;
            case 3:
                var value = /** @type {!proto.IM.Call.CallProviderEventType} */ reader.readEnum();
                msg.setEventType(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCallId(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSessionId(value);
                break;
            case 6:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttendanceLegId(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setProviderIdentity(value);
                break;
            case 8:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setRawBodyHash(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readUint64();
                msg.setProviderOccurredAtMs(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.CallProviderFact.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.CallProviderFact.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.CallProviderFact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallProviderFact.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSchemaVersion();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getProviderEventId();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getEventType();
    if (f !== 0.0) {
        writer.writeEnum(3, f);
    }
    f = message.getCallId_asU8();
    if (f.length > 0) {
        writer.writeBytes(4, f);
    }
    f = message.getSessionId_asU8();
    if (f.length > 0) {
        writer.writeBytes(5, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 6);
    if (f != null) {
        writer.writeBytes(6, f);
    }
    f = message.getProviderIdentity();
    if (f.length > 0) {
        writer.writeString(7, f);
    }
    f = message.getRawBodyHash_asU8();
    if (f.length > 0) {
        writer.writeBytes(8, f);
    }
    f = message.getProviderOccurredAtMs();
    if (f !== 0) {
        writer.writeUint64(9, f);
    }
};
/**
 * optional uint32 schema_version = 1;
 * @return {number}
 */ proto.IM.Call.CallProviderFact.prototype.getSchemaVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallProviderFact} returns this
 */ proto.IM.Call.CallProviderFact.prototype.setSchemaVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string provider_event_id = 2;
 * @return {string}
 */ proto.IM.Call.CallProviderFact.prototype.getProviderEventId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.CallProviderFact} returns this
 */ proto.IM.Call.CallProviderFact.prototype.setProviderEventId = function(value) {
    return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional CallProviderEventType event_type = 3;
 * @return {!proto.IM.Call.CallProviderEventType}
 */ proto.IM.Call.CallProviderFact.prototype.getEventType = function() {
    return /** @type {!proto.IM.Call.CallProviderEventType} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.IM.Call.CallProviderEventType} value
 * @return {!proto.IM.Call.CallProviderFact} returns this
 */ proto.IM.Call.CallProviderFact.prototype.setEventType = function(value) {
    return jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional bytes call_id = 4;
 * @return {string}
 */ proto.IM.Call.CallProviderFact.prototype.getCallId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes call_id = 4;
 * This is a type-conversion wrapper around `getCallId()`
 * @return {string}
 */ proto.IM.Call.CallProviderFact.prototype.getCallId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCallId());
};
/**
 * optional bytes call_id = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallProviderFact.prototype.getCallId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCallId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallProviderFact} returns this
 */ proto.IM.Call.CallProviderFact.prototype.setCallId = function(value) {
    return jspb.Message.setProto3BytesField(this, 4, value);
};
/**
 * optional bytes session_id = 5;
 * @return {string}
 */ proto.IM.Call.CallProviderFact.prototype.getSessionId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes session_id = 5;
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {string}
 */ proto.IM.Call.CallProviderFact.prototype.getSessionId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSessionId());
};
/**
 * optional bytes session_id = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallProviderFact.prototype.getSessionId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSessionId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallProviderFact} returns this
 */ proto.IM.Call.CallProviderFact.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3BytesField(this, 5, value);
};
/**
 * optional bytes attendance_leg_id = 6;
 * @return {string}
 */ proto.IM.Call.CallProviderFact.prototype.getAttendanceLegId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 6, "");
};
/**
 * optional bytes attendance_leg_id = 6;
 * This is a type-conversion wrapper around `getAttendanceLegId()`
 * @return {string}
 */ proto.IM.Call.CallProviderFact.prototype.getAttendanceLegId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttendanceLegId());
};
/**
 * optional bytes attendance_leg_id = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttendanceLegId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallProviderFact.prototype.getAttendanceLegId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttendanceLegId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallProviderFact} returns this
 */ proto.IM.Call.CallProviderFact.prototype.setAttendanceLegId = function(value) {
    return jspb.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallProviderFact} returns this
 */ proto.IM.Call.CallProviderFact.prototype.clearAttendanceLegId = function() {
    return jspb.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallProviderFact.prototype.hasAttendanceLegId = function() {
    return jspb.Message.getField(this, 6) != null;
};
/**
 * optional string provider_identity = 7;
 * @return {string}
 */ proto.IM.Call.CallProviderFact.prototype.getProviderIdentity = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.CallProviderFact} returns this
 */ proto.IM.Call.CallProviderFact.prototype.setProviderIdentity = function(value) {
    return jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional bytes raw_body_hash = 8;
 * @return {string}
 */ proto.IM.Call.CallProviderFact.prototype.getRawBodyHash = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 8, "");
};
/**
 * optional bytes raw_body_hash = 8;
 * This is a type-conversion wrapper around `getRawBodyHash()`
 * @return {string}
 */ proto.IM.Call.CallProviderFact.prototype.getRawBodyHash_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getRawBodyHash());
};
/**
 * optional bytes raw_body_hash = 8;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getRawBodyHash()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallProviderFact.prototype.getRawBodyHash_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getRawBodyHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallProviderFact} returns this
 */ proto.IM.Call.CallProviderFact.prototype.setRawBodyHash = function(value) {
    return jspb.Message.setProto3BytesField(this, 8, value);
};
/**
 * optional uint64 provider_occurred_at_ms = 9;
 * @return {number}
 */ proto.IM.Call.CallProviderFact.prototype.getProviderOccurredAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallProviderFact} returns this
 */ proto.IM.Call.CallProviderFact.prototype.setProviderOccurredAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 9, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.CallOwnershipCommand.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.CallOwnershipCommand.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.CallOwnershipCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallOwnershipCommand.toObject = function(includeInstance, msg) {
        var f, obj = {
            commandId: msg.getCommandId_asB64(),
            commandType: jspb.Message.getFieldWithDefault(msg, 2, 0),
            callId: msg.getCallId_asB64(),
            sessionId: msg.getSessionId_asB64(),
            actorUserId: jspb.Message.getFieldWithDefault(msg, 5, 0),
            opaqueDeviceRefHash: msg.getOpaqueDeviceRefHash_asB64(),
            expectedVersion: jspb.Message.getFieldWithDefault(msg, 7, 0),
            fence: jspb.Message.getFieldWithDefault(msg, 8, 0),
            requestedAtMs: jspb.Message.getFieldWithDefault(msg, 9, 0),
            nonce: msg.getNonce_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.CallOwnershipCommand}
 */ proto.IM.Call.CallOwnershipCommand.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.CallOwnershipCommand;
    return proto.IM.Call.CallOwnershipCommand.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.CallOwnershipCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.CallOwnershipCommand}
 */ proto.IM.Call.CallOwnershipCommand.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCommandId(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.Call.CallCommandType} */ reader.readEnum();
                msg.setCommandType(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCallId(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSessionId(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setActorUserId(value);
                break;
            case 6:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setOpaqueDeviceRefHash(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readUint64();
                msg.setExpectedVersion(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint64();
                msg.setFence(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readUint64();
                msg.setRequestedAtMs(value);
                break;
            case 10:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setNonce(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.CallOwnershipCommand.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.CallOwnershipCommand.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.CallOwnershipCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallOwnershipCommand.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCommandId_asU8();
    if (f.length > 0) {
        writer.writeBytes(1, f);
    }
    f = message.getCommandType();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
    f = message.getCallId_asU8();
    if (f.length > 0) {
        writer.writeBytes(3, f);
    }
    f = message.getSessionId_asU8();
    if (f.length > 0) {
        writer.writeBytes(4, f);
    }
    f = message.getActorUserId();
    if (f !== 0) {
        writer.writeUint32(5, f);
    }
    f = message.getOpaqueDeviceRefHash_asU8();
    if (f.length > 0) {
        writer.writeBytes(6, f);
    }
    f = message.getExpectedVersion();
    if (f !== 0) {
        writer.writeUint64(7, f);
    }
    f = message.getFence();
    if (f !== 0) {
        writer.writeUint64(8, f);
    }
    f = message.getRequestedAtMs();
    if (f !== 0) {
        writer.writeUint64(9, f);
    }
    f = message.getNonce_asU8();
    if (f.length > 0) {
        writer.writeBytes(10, f);
    }
};
/**
 * optional bytes command_id = 1;
 * @return {string}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getCommandId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes command_id = 1;
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {string}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getCommandId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCommandId());
};
/**
 * optional bytes command_id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getCommandId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCommandId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallOwnershipCommand} returns this
 */ proto.IM.Call.CallOwnershipCommand.prototype.setCommandId = function(value) {
    return jspb.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional CallCommandType command_type = 2;
 * @return {!proto.IM.Call.CallCommandType}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getCommandType = function() {
    return /** @type {!proto.IM.Call.CallCommandType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.Call.CallCommandType} value
 * @return {!proto.IM.Call.CallOwnershipCommand} returns this
 */ proto.IM.Call.CallOwnershipCommand.prototype.setCommandType = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional bytes call_id = 3;
 * @return {string}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getCallId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes call_id = 3;
 * This is a type-conversion wrapper around `getCallId()`
 * @return {string}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getCallId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCallId());
};
/**
 * optional bytes call_id = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getCallId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCallId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallOwnershipCommand} returns this
 */ proto.IM.Call.CallOwnershipCommand.prototype.setCallId = function(value) {
    return jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional bytes session_id = 4;
 * @return {string}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getSessionId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes session_id = 4;
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {string}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getSessionId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSessionId());
};
/**
 * optional bytes session_id = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getSessionId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSessionId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallOwnershipCommand} returns this
 */ proto.IM.Call.CallOwnershipCommand.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3BytesField(this, 4, value);
};
/**
 * optional uint32 actor_user_id = 5;
 * @return {number}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getActorUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallOwnershipCommand} returns this
 */ proto.IM.Call.CallOwnershipCommand.prototype.setActorUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional bytes opaque_device_ref_hash = 6;
 * @return {string}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getOpaqueDeviceRefHash = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 6, "");
};
/**
 * optional bytes opaque_device_ref_hash = 6;
 * This is a type-conversion wrapper around `getOpaqueDeviceRefHash()`
 * @return {string}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getOpaqueDeviceRefHash_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getOpaqueDeviceRefHash());
};
/**
 * optional bytes opaque_device_ref_hash = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOpaqueDeviceRefHash()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getOpaqueDeviceRefHash_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getOpaqueDeviceRefHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallOwnershipCommand} returns this
 */ proto.IM.Call.CallOwnershipCommand.prototype.setOpaqueDeviceRefHash = function(value) {
    return jspb.Message.setProto3BytesField(this, 6, value);
};
/**
 * optional uint64 expected_version = 7;
 * @return {number}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getExpectedVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallOwnershipCommand} returns this
 */ proto.IM.Call.CallOwnershipCommand.prototype.setExpectedVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * optional uint64 fence = 8;
 * @return {number}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getFence = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallOwnershipCommand} returns this
 */ proto.IM.Call.CallOwnershipCommand.prototype.setFence = function(value) {
    return jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * optional uint64 requested_at_ms = 9;
 * @return {number}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getRequestedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallOwnershipCommand} returns this
 */ proto.IM.Call.CallOwnershipCommand.prototype.setRequestedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 9, value);
};
/**
 * optional bytes nonce = 10;
 * @return {string}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getNonce = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 10, "");
};
/**
 * optional bytes nonce = 10;
 * This is a type-conversion wrapper around `getNonce()`
 * @return {string}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getNonce_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getNonce());
};
/**
 * optional bytes nonce = 10;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getNonce()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallOwnershipCommand.prototype.getNonce_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getNonce());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallOwnershipCommand} returns this
 */ proto.IM.Call.CallOwnershipCommand.prototype.setNonce = function(value) {
    return jspb.Message.setProto3BytesField(this, 10, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.CallCommandQuery.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.CallCommandQuery.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.CallCommandQuery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallCommandQuery.toObject = function(includeInstance, msg) {
        var f, obj = {
            commandId: msg.getCommandId_asB64(),
            actorUserId: jspb.Message.getFieldWithDefault(msg, 2, 0),
            requestedAtMs: jspb.Message.getFieldWithDefault(msg, 3, 0),
            nonce: msg.getNonce_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.CallCommandQuery}
 */ proto.IM.Call.CallCommandQuery.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.CallCommandQuery;
    return proto.IM.Call.CallCommandQuery.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.CallCommandQuery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.CallCommandQuery}
 */ proto.IM.Call.CallCommandQuery.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCommandId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setActorUserId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint64();
                msg.setRequestedAtMs(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setNonce(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.CallCommandQuery.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.CallCommandQuery.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.CallCommandQuery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallCommandQuery.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCommandId_asU8();
    if (f.length > 0) {
        writer.writeBytes(1, f);
    }
    f = message.getActorUserId();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = message.getRequestedAtMs();
    if (f !== 0) {
        writer.writeUint64(3, f);
    }
    f = message.getNonce_asU8();
    if (f.length > 0) {
        writer.writeBytes(4, f);
    }
};
/**
 * optional bytes command_id = 1;
 * @return {string}
 */ proto.IM.Call.CallCommandQuery.prototype.getCommandId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes command_id = 1;
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {string}
 */ proto.IM.Call.CallCommandQuery.prototype.getCommandId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCommandId());
};
/**
 * optional bytes command_id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallCommandQuery.prototype.getCommandId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCommandId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallCommandQuery} returns this
 */ proto.IM.Call.CallCommandQuery.prototype.setCommandId = function(value) {
    return jspb.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional uint32 actor_user_id = 2;
 * @return {number}
 */ proto.IM.Call.CallCommandQuery.prototype.getActorUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallCommandQuery} returns this
 */ proto.IM.Call.CallCommandQuery.prototype.setActorUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional uint64 requested_at_ms = 3;
 * @return {number}
 */ proto.IM.Call.CallCommandQuery.prototype.getRequestedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallCommandQuery} returns this
 */ proto.IM.Call.CallCommandQuery.prototype.setRequestedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional bytes nonce = 4;
 * @return {string}
 */ proto.IM.Call.CallCommandQuery.prototype.getNonce = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes nonce = 4;
 * This is a type-conversion wrapper around `getNonce()`
 * @return {string}
 */ proto.IM.Call.CallCommandQuery.prototype.getNonce_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getNonce());
};
/**
 * optional bytes nonce = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getNonce()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallCommandQuery.prototype.getNonce_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getNonce());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallCommandQuery} returns this
 */ proto.IM.Call.CallCommandQuery.prototype.setNonce = function(value) {
    return jspb.Message.setProto3BytesField(this, 4, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.CallParticipantReport.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.CallParticipantReport.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.CallParticipantReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallParticipantReport.toObject = function(includeInstance, msg) {
        var f, obj = {
            callId: msg.getCallId_asB64(),
            sessionId: msg.getSessionId_asB64(),
            actorUserId: jspb.Message.getFieldWithDefault(msg, 3, 0),
            reportType: jspb.Message.getFieldWithDefault(msg, 4, 0),
            reportSequence: jspb.Message.getFieldWithDefault(msg, 5, 0),
            fence: jspb.Message.getFieldWithDefault(msg, 6, 0),
            observedAtMs: jspb.Message.getFieldWithDefault(msg, 7, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.CallParticipantReport}
 */ proto.IM.Call.CallParticipantReport.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.CallParticipantReport;
    return proto.IM.Call.CallParticipantReport.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.CallParticipantReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.CallParticipantReport}
 */ proto.IM.Call.CallParticipantReport.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCallId(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSessionId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setActorUserId(value);
                break;
            case 4:
                var value = /** @type {!proto.IM.Call.CallParticipantReportType} */ reader.readEnum();
                msg.setReportType(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint64();
                msg.setReportSequence(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint64();
                msg.setFence(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readUint64();
                msg.setObservedAtMs(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.CallParticipantReport.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.CallParticipantReport.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.CallParticipantReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallParticipantReport.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCallId_asU8();
    if (f.length > 0) {
        writer.writeBytes(1, f);
    }
    f = message.getSessionId_asU8();
    if (f.length > 0) {
        writer.writeBytes(2, f);
    }
    f = message.getActorUserId();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
    f = message.getReportType();
    if (f !== 0.0) {
        writer.writeEnum(4, f);
    }
    f = message.getReportSequence();
    if (f !== 0) {
        writer.writeUint64(5, f);
    }
    f = message.getFence();
    if (f !== 0) {
        writer.writeUint64(6, f);
    }
    f = message.getObservedAtMs();
    if (f !== 0) {
        writer.writeUint64(7, f);
    }
};
/**
 * optional bytes call_id = 1;
 * @return {string}
 */ proto.IM.Call.CallParticipantReport.prototype.getCallId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes call_id = 1;
 * This is a type-conversion wrapper around `getCallId()`
 * @return {string}
 */ proto.IM.Call.CallParticipantReport.prototype.getCallId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCallId());
};
/**
 * optional bytes call_id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallParticipantReport.prototype.getCallId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCallId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallParticipantReport} returns this
 */ proto.IM.Call.CallParticipantReport.prototype.setCallId = function(value) {
    return jspb.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional bytes session_id = 2;
 * @return {string}
 */ proto.IM.Call.CallParticipantReport.prototype.getSessionId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes session_id = 2;
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {string}
 */ proto.IM.Call.CallParticipantReport.prototype.getSessionId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSessionId());
};
/**
 * optional bytes session_id = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallParticipantReport.prototype.getSessionId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSessionId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallParticipantReport} returns this
 */ proto.IM.Call.CallParticipantReport.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional uint32 actor_user_id = 3;
 * @return {number}
 */ proto.IM.Call.CallParticipantReport.prototype.getActorUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallParticipantReport} returns this
 */ proto.IM.Call.CallParticipantReport.prototype.setActorUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional CallParticipantReportType report_type = 4;
 * @return {!proto.IM.Call.CallParticipantReportType}
 */ proto.IM.Call.CallParticipantReport.prototype.getReportType = function() {
    return /** @type {!proto.IM.Call.CallParticipantReportType} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.IM.Call.CallParticipantReportType} value
 * @return {!proto.IM.Call.CallParticipantReport} returns this
 */ proto.IM.Call.CallParticipantReport.prototype.setReportType = function(value) {
    return jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional uint64 report_sequence = 5;
 * @return {number}
 */ proto.IM.Call.CallParticipantReport.prototype.getReportSequence = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallParticipantReport} returns this
 */ proto.IM.Call.CallParticipantReport.prototype.setReportSequence = function(value) {
    return jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional uint64 fence = 6;
 * @return {number}
 */ proto.IM.Call.CallParticipantReport.prototype.getFence = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallParticipantReport} returns this
 */ proto.IM.Call.CallParticipantReport.prototype.setFence = function(value) {
    return jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional uint64 observed_at_ms = 7;
 * @return {number}
 */ proto.IM.Call.CallParticipantReport.prototype.getObservedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallParticipantReport} returns this
 */ proto.IM.Call.CallParticipantReport.prototype.setObservedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 7, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.CallParticipantReportResult.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.CallParticipantReportResult.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.CallParticipantReportResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallParticipantReportResult.toObject = function(includeInstance, msg) {
        var f, obj = {
            resultCode: jspb.Message.getFieldWithDefault(msg, 1, 0),
            callId: msg.getCallId_asB64(),
            sessionId: msg.getSessionId_asB64(),
            actorUserId: jspb.Message.getFieldWithDefault(msg, 4, 0),
            reportType: jspb.Message.getFieldWithDefault(msg, 5, 0),
            acceptedSequence: jspb.Message.getFieldWithDefault(msg, 6, 0),
            aggregateVersion: jspb.Message.getFieldWithDefault(msg, 7, 0),
            fence: jspb.Message.getFieldWithDefault(msg, 8, 0),
            leaseDeadlineAtMs: jspb.Message.getFieldWithDefault(msg, 9, 0),
            connectedAtMs: jspb.Message.getFieldWithDefault(msg, 10, 0),
            committedAtMs: jspb.Message.getFieldWithDefault(msg, 11, 0),
            detailCode: jspb.Message.getFieldWithDefault(msg, 12, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.CallParticipantReportResult}
 */ proto.IM.Call.CallParticipantReportResult.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.CallParticipantReportResult;
    return proto.IM.Call.CallParticipantReportResult.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.CallParticipantReportResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.CallParticipantReportResult}
 */ proto.IM.Call.CallParticipantReportResult.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.IM.Call.CallResultCode} */ reader.readEnum();
                msg.setResultCode(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCallId(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSessionId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setActorUserId(value);
                break;
            case 5:
                var value = /** @type {!proto.IM.Call.CallParticipantReportType} */ reader.readEnum();
                msg.setReportType(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint64();
                msg.setAcceptedSequence(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readUint64();
                msg.setAggregateVersion(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint64();
                msg.setFence(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readUint64();
                msg.setLeaseDeadlineAtMs(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readUint64();
                msg.setConnectedAtMs(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readUint64();
                msg.setCommittedAtMs(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setDetailCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.CallParticipantReportResult.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.CallParticipantReportResult.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.CallParticipantReportResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallParticipantReportResult.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getResultCode();
    if (f !== 0.0) {
        writer.writeEnum(1, f);
    }
    f = message.getCallId_asU8();
    if (f.length > 0) {
        writer.writeBytes(2, f);
    }
    f = message.getSessionId_asU8();
    if (f.length > 0) {
        writer.writeBytes(3, f);
    }
    f = message.getActorUserId();
    if (f !== 0) {
        writer.writeUint32(4, f);
    }
    f = message.getReportType();
    if (f !== 0.0) {
        writer.writeEnum(5, f);
    }
    f = message.getAcceptedSequence();
    if (f !== 0) {
        writer.writeUint64(6, f);
    }
    f = message.getAggregateVersion();
    if (f !== 0) {
        writer.writeUint64(7, f);
    }
    f = message.getFence();
    if (f !== 0) {
        writer.writeUint64(8, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 9);
    if (f != null) {
        writer.writeUint64(9, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 10);
    if (f != null) {
        writer.writeUint64(10, f);
    }
    f = message.getCommittedAtMs();
    if (f !== 0) {
        writer.writeUint64(11, f);
    }
    f = /** @type {string} */ jspb.Message.getField(message, 12);
    if (f != null) {
        writer.writeString(12, f);
    }
};
/**
 * optional CallResultCode result_code = 1;
 * @return {!proto.IM.Call.CallResultCode}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getResultCode = function() {
    return /** @type {!proto.IM.Call.CallResultCode} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.IM.Call.CallResultCode} value
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.setResultCode = function(value) {
    return jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional bytes call_id = 2;
 * @return {string}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getCallId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes call_id = 2;
 * This is a type-conversion wrapper around `getCallId()`
 * @return {string}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getCallId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCallId());
};
/**
 * optional bytes call_id = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getCallId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCallId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.setCallId = function(value) {
    return jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional bytes session_id = 3;
 * @return {string}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getSessionId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes session_id = 3;
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {string}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getSessionId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSessionId());
};
/**
 * optional bytes session_id = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getSessionId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSessionId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional uint32 actor_user_id = 4;
 * @return {number}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getActorUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.setActorUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional CallParticipantReportType report_type = 5;
 * @return {!proto.IM.Call.CallParticipantReportType}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getReportType = function() {
    return /** @type {!proto.IM.Call.CallParticipantReportType} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.IM.Call.CallParticipantReportType} value
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.setReportType = function(value) {
    return jspb.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional uint64 accepted_sequence = 6;
 * @return {number}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getAcceptedSequence = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.setAcceptedSequence = function(value) {
    return jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional uint64 aggregate_version = 7;
 * @return {number}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getAggregateVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.setAggregateVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * optional uint64 fence = 8;
 * @return {number}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getFence = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.setFence = function(value) {
    return jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * optional uint64 lease_deadline_at_ms = 9;
 * @return {number}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getLeaseDeadlineAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.setLeaseDeadlineAtMs = function(value) {
    return jspb.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.clearLeaseDeadlineAtMs = function() {
    return jspb.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallParticipantReportResult.prototype.hasLeaseDeadlineAtMs = function() {
    return jspb.Message.getField(this, 9) != null;
};
/**
 * optional uint64 connected_at_ms = 10;
 * @return {number}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getConnectedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.setConnectedAtMs = function(value) {
    return jspb.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.clearConnectedAtMs = function() {
    return jspb.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallParticipantReportResult.prototype.hasConnectedAtMs = function() {
    return jspb.Message.getField(this, 10) != null;
};
/**
 * optional uint64 committed_at_ms = 11;
 * @return {number}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getCommittedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.setCommittedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 11, value);
};
/**
 * optional string detail_code = 12;
 * @return {string}
 */ proto.IM.Call.CallParticipantReportResult.prototype.getDetailCode = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.setDetailCode = function(value) {
    return jspb.Message.setField(this, 12, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallParticipantReportResult} returns this
 */ proto.IM.Call.CallParticipantReportResult.prototype.clearDetailCode = function() {
    return jspb.Message.setField(this, 12, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallParticipantReportResult.prototype.hasDetailCode = function() {
    return jspb.Message.getField(this, 12) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.IM.Call.CallSessionCapabilityClaims.repeatedFields_ = [
    7
];
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.CallSessionCapabilityClaims.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.CallSessionCapabilityClaims} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallSessionCapabilityClaims.toObject = function(includeInstance, msg) {
        var f, obj = {
            schemaVersion: jspb.Message.getFieldWithDefault(msg, 1, 0),
            callId: msg.getCallId_asB64(),
            sessionId: msg.getSessionId_asB64(),
            userId: jspb.Message.getFieldWithDefault(msg, 4, 0),
            opaqueDeviceRefHash: msg.getOpaqueDeviceRefHash_asB64(),
            fence: jspb.Message.getFieldWithDefault(msg, 6, 0),
            allowedOperationsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
            issuedAtMs: jspb.Message.getFieldWithDefault(msg, 8, 0),
            expiresAtMs: jspb.Message.getFieldWithDefault(msg, 9, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.CallSessionCapabilityClaims}
 */ proto.IM.Call.CallSessionCapabilityClaims.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.CallSessionCapabilityClaims;
    return proto.IM.Call.CallSessionCapabilityClaims.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.CallSessionCapabilityClaims} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.CallSessionCapabilityClaims}
 */ proto.IM.Call.CallSessionCapabilityClaims.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSchemaVersion(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCallId(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSessionId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setOpaqueDeviceRefHash(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint64();
                msg.setFence(value);
                break;
            case 7:
                var values = /** @type {!Array<!proto.IM.Call.CallSignalingOperation>} */ reader.isDelimited() ? reader.readPackedEnum() : [
                    reader.readEnum()
                ];
                for(var i = 0; i < values.length; i++){
                    msg.addAllowedOperations(values[i]);
                }
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint64();
                msg.setIssuedAtMs(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readUint64();
                msg.setExpiresAtMs(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.CallSessionCapabilityClaims.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.CallSessionCapabilityClaims} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallSessionCapabilityClaims.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSchemaVersion();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getCallId_asU8();
    if (f.length > 0) {
        writer.writeBytes(2, f);
    }
    f = message.getSessionId_asU8();
    if (f.length > 0) {
        writer.writeBytes(3, f);
    }
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(4, f);
    }
    f = message.getOpaqueDeviceRefHash_asU8();
    if (f.length > 0) {
        writer.writeBytes(5, f);
    }
    f = message.getFence();
    if (f !== 0) {
        writer.writeUint64(6, f);
    }
    f = message.getAllowedOperationsList();
    if (f.length > 0) {
        writer.writePackedEnum(7, f);
    }
    f = message.getIssuedAtMs();
    if (f !== 0) {
        writer.writeUint64(8, f);
    }
    f = message.getExpiresAtMs();
    if (f !== 0) {
        writer.writeUint64(9, f);
    }
};
/**
 * optional uint32 schema_version = 1;
 * @return {number}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getSchemaVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallSessionCapabilityClaims} returns this
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.setSchemaVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional bytes call_id = 2;
 * @return {string}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getCallId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes call_id = 2;
 * This is a type-conversion wrapper around `getCallId()`
 * @return {string}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getCallId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCallId());
};
/**
 * optional bytes call_id = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getCallId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCallId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallSessionCapabilityClaims} returns this
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.setCallId = function(value) {
    return jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional bytes session_id = 3;
 * @return {string}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getSessionId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes session_id = 3;
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {string}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getSessionId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSessionId());
};
/**
 * optional bytes session_id = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getSessionId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSessionId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallSessionCapabilityClaims} returns this
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional uint32 user_id = 4;
 * @return {number}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallSessionCapabilityClaims} returns this
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional bytes opaque_device_ref_hash = 5;
 * @return {string}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getOpaqueDeviceRefHash = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes opaque_device_ref_hash = 5;
 * This is a type-conversion wrapper around `getOpaqueDeviceRefHash()`
 * @return {string}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getOpaqueDeviceRefHash_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getOpaqueDeviceRefHash());
};
/**
 * optional bytes opaque_device_ref_hash = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOpaqueDeviceRefHash()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getOpaqueDeviceRefHash_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getOpaqueDeviceRefHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallSessionCapabilityClaims} returns this
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.setOpaqueDeviceRefHash = function(value) {
    return jspb.Message.setProto3BytesField(this, 5, value);
};
/**
 * optional uint64 fence = 6;
 * @return {number}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getFence = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallSessionCapabilityClaims} returns this
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.setFence = function(value) {
    return jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * repeated CallSignalingOperation allowed_operations = 7;
 * @return {!Array<!proto.IM.Call.CallSignalingOperation>}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getAllowedOperationsList = function() {
    return /** @type {!Array<!proto.IM.Call.CallSignalingOperation>} */ jspb.Message.getRepeatedField(this, 7);
};
/**
 * @param {!Array<!proto.IM.Call.CallSignalingOperation>} value
 * @return {!proto.IM.Call.CallSessionCapabilityClaims} returns this
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.setAllowedOperationsList = function(value) {
    return jspb.Message.setField(this, 7, value || []);
};
/**
 * @param {!proto.IM.Call.CallSignalingOperation} value
 * @param {number=} opt_index
 * @return {!proto.IM.Call.CallSessionCapabilityClaims} returns this
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.addAllowedOperations = function(value, opt_index) {
    return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.IM.Call.CallSessionCapabilityClaims} returns this
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.clearAllowedOperationsList = function() {
    return this.setAllowedOperationsList([]);
};
/**
 * optional uint64 issued_at_ms = 8;
 * @return {number}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getIssuedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallSessionCapabilityClaims} returns this
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.setIssuedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * optional uint64 expires_at_ms = 9;
 * @return {number}
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.getExpiresAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallSessionCapabilityClaims} returns this
 */ proto.IM.Call.CallSessionCapabilityClaims.prototype.setExpiresAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 9, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.SignedCallSessionCapability.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.SignedCallSessionCapability.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.SignedCallSessionCapability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.SignedCallSessionCapability.toObject = function(includeInstance, msg) {
        var f, obj = {
            serializedClaims: msg.getSerializedClaims_asB64(),
            signature: msg.getSignature_asB64(),
            keyId: jspb.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.SignedCallSessionCapability}
 */ proto.IM.Call.SignedCallSessionCapability.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.SignedCallSessionCapability;
    return proto.IM.Call.SignedCallSessionCapability.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.SignedCallSessionCapability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.SignedCallSessionCapability}
 */ proto.IM.Call.SignedCallSessionCapability.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSerializedClaims(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setKeyId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.SignedCallSessionCapability.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.SignedCallSessionCapability.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.SignedCallSessionCapability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.SignedCallSessionCapability.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSerializedClaims_asU8();
    if (f.length > 0) {
        writer.writeBytes(1, f);
    }
    f = message.getSignature_asU8();
    if (f.length > 0) {
        writer.writeBytes(2, f);
    }
    f = message.getKeyId();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
};
/**
 * optional bytes serialized_claims = 1;
 * @return {string}
 */ proto.IM.Call.SignedCallSessionCapability.prototype.getSerializedClaims = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes serialized_claims = 1;
 * This is a type-conversion wrapper around `getSerializedClaims()`
 * @return {string}
 */ proto.IM.Call.SignedCallSessionCapability.prototype.getSerializedClaims_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSerializedClaims());
};
/**
 * optional bytes serialized_claims = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSerializedClaims()`
 * @return {!Uint8Array}
 */ proto.IM.Call.SignedCallSessionCapability.prototype.getSerializedClaims_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSerializedClaims());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.SignedCallSessionCapability} returns this
 */ proto.IM.Call.SignedCallSessionCapability.prototype.setSerializedClaims = function(value) {
    return jspb.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional bytes signature = 2;
 * @return {string}
 */ proto.IM.Call.SignedCallSessionCapability.prototype.getSignature = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes signature = 2;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.IM.Call.SignedCallSessionCapability.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.IM.Call.SignedCallSessionCapability.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.SignedCallSessionCapability} returns this
 */ proto.IM.Call.SignedCallSessionCapability.prototype.setSignature = function(value) {
    return jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional string key_id = 3;
 * @return {string}
 */ proto.IM.Call.SignedCallSessionCapability.prototype.getKeyId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.SignedCallSessionCapability} returns this
 */ proto.IM.Call.SignedCallSessionCapability.prototype.setKeyId = function(value) {
    return jspb.Message.setProto3StringField(this, 3, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.CallLifecycleResult.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.CallLifecycleResult.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.CallLifecycleResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallLifecycleResult.toObject = function(includeInstance, msg) {
        var f, obj = {
            resultCode: jspb.Message.getFieldWithDefault(msg, 1, 0),
            commandId: msg.getCommandId_asB64(),
            callId: msg.getCallId_asB64(),
            sessionId: msg.getSessionId_asB64(),
            aggregateVersion: jspb.Message.getFieldWithDefault(msg, 5, 0),
            fence: jspb.Message.getFieldWithDefault(msg, 6, 0),
            sessionCapability: (f = msg.getSessionCapability()) && proto.IM.Call.SignedCallSessionCapability.toObject(includeInstance, f),
            committedAtMs: jspb.Message.getFieldWithDefault(msg, 8, 0),
            detailCode: jspb.Message.getFieldWithDefault(msg, 9, ""),
            initiatorUserId: jspb.Message.getFieldWithDefault(msg, 10, 0),
            inviteeUserId: jspb.Message.getFieldWithDefault(msg, 11, 0),
            mediaKind: jspb.Message.getFieldWithDefault(msg, 12, 0),
            lifecycleState: jspb.Message.getFieldWithDefault(msg, 13, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.CallLifecycleResult}
 */ proto.IM.Call.CallLifecycleResult.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.CallLifecycleResult;
    return proto.IM.Call.CallLifecycleResult.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.CallLifecycleResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.CallLifecycleResult}
 */ proto.IM.Call.CallLifecycleResult.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.IM.Call.CallResultCode} */ reader.readEnum();
                msg.setResultCode(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCommandId(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCallId(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSessionId(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint64();
                msg.setAggregateVersion(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint64();
                msg.setFence(value);
                break;
            case 7:
                var value = new proto.IM.Call.SignedCallSessionCapability;
                reader.readMessage(value, proto.IM.Call.SignedCallSessionCapability.deserializeBinaryFromReader);
                msg.setSessionCapability(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint64();
                msg.setCommittedAtMs(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setDetailCode(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readUint32();
                msg.setInitiatorUserId(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readUint32();
                msg.setInviteeUserId(value);
                break;
            case 12:
                var value = /** @type {!proto.IM.Call.CallMediaKind} */ reader.readEnum();
                msg.setMediaKind(value);
                break;
            case 13:
                var value = /** @type {!proto.IM.Call.CallLifecycleState} */ reader.readEnum();
                msg.setLifecycleState(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.CallLifecycleResult.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.CallLifecycleResult.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.CallLifecycleResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallLifecycleResult.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getResultCode();
    if (f !== 0.0) {
        writer.writeEnum(1, f);
    }
    f = message.getCommandId_asU8();
    if (f.length > 0) {
        writer.writeBytes(2, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 3);
    if (f != null) {
        writer.writeBytes(3, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 4);
    if (f != null) {
        writer.writeBytes(4, f);
    }
    f = message.getAggregateVersion();
    if (f !== 0) {
        writer.writeUint64(5, f);
    }
    f = message.getFence();
    if (f !== 0) {
        writer.writeUint64(6, f);
    }
    f = message.getSessionCapability();
    if (f != null) {
        writer.writeMessage(7, f, proto.IM.Call.SignedCallSessionCapability.serializeBinaryToWriter);
    }
    f = message.getCommittedAtMs();
    if (f !== 0) {
        writer.writeUint64(8, f);
    }
    f = /** @type {string} */ jspb.Message.getField(message, 9);
    if (f != null) {
        writer.writeString(9, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 10);
    if (f != null) {
        writer.writeUint32(10, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 11);
    if (f != null) {
        writer.writeUint32(11, f);
    }
    f = /** @type {!proto.IM.Call.CallMediaKind} */ jspb.Message.getField(message, 12);
    if (f != null) {
        writer.writeEnum(12, f);
    }
    f = /** @type {!proto.IM.Call.CallLifecycleState} */ jspb.Message.getField(message, 13);
    if (f != null) {
        writer.writeEnum(13, f);
    }
};
/**
 * optional CallResultCode result_code = 1;
 * @return {!proto.IM.Call.CallResultCode}
 */ proto.IM.Call.CallLifecycleResult.prototype.getResultCode = function() {
    return /** @type {!proto.IM.Call.CallResultCode} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.IM.Call.CallResultCode} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.setResultCode = function(value) {
    return jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional bytes command_id = 2;
 * @return {string}
 */ proto.IM.Call.CallLifecycleResult.prototype.getCommandId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes command_id = 2;
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {string}
 */ proto.IM.Call.CallLifecycleResult.prototype.getCommandId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCommandId());
};
/**
 * optional bytes command_id = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCommandId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallLifecycleResult.prototype.getCommandId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCommandId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.setCommandId = function(value) {
    return jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional bytes call_id = 3;
 * @return {string}
 */ proto.IM.Call.CallLifecycleResult.prototype.getCallId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes call_id = 3;
 * This is a type-conversion wrapper around `getCallId()`
 * @return {string}
 */ proto.IM.Call.CallLifecycleResult.prototype.getCallId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCallId());
};
/**
 * optional bytes call_id = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallLifecycleResult.prototype.getCallId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCallId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.setCallId = function(value) {
    return jspb.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.clearCallId = function() {
    return jspb.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallLifecycleResult.prototype.hasCallId = function() {
    return jspb.Message.getField(this, 3) != null;
};
/**
 * optional bytes session_id = 4;
 * @return {string}
 */ proto.IM.Call.CallLifecycleResult.prototype.getSessionId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes session_id = 4;
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {string}
 */ proto.IM.Call.CallLifecycleResult.prototype.getSessionId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSessionId());
};
/**
 * optional bytes session_id = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallLifecycleResult.prototype.getSessionId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSessionId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.setSessionId = function(value) {
    return jspb.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.clearSessionId = function() {
    return jspb.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallLifecycleResult.prototype.hasSessionId = function() {
    return jspb.Message.getField(this, 4) != null;
};
/**
 * optional uint64 aggregate_version = 5;
 * @return {number}
 */ proto.IM.Call.CallLifecycleResult.prototype.getAggregateVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.setAggregateVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional uint64 fence = 6;
 * @return {number}
 */ proto.IM.Call.CallLifecycleResult.prototype.getFence = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.setFence = function(value) {
    return jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional SignedCallSessionCapability session_capability = 7;
 * @return {?proto.IM.Call.SignedCallSessionCapability}
 */ proto.IM.Call.CallLifecycleResult.prototype.getSessionCapability = function() {
    return /** @type{?proto.IM.Call.SignedCallSessionCapability} */ jspb.Message.getWrapperField(this, proto.IM.Call.SignedCallSessionCapability, 7);
};
/**
 * @param {?proto.IM.Call.SignedCallSessionCapability|undefined} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
*/ proto.IM.Call.CallLifecycleResult.prototype.setSessionCapability = function(value) {
    return jspb.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.clearSessionCapability = function() {
    return this.setSessionCapability(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallLifecycleResult.prototype.hasSessionCapability = function() {
    return jspb.Message.getField(this, 7) != null;
};
/**
 * optional uint64 committed_at_ms = 8;
 * @return {number}
 */ proto.IM.Call.CallLifecycleResult.prototype.getCommittedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.setCommittedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * optional string detail_code = 9;
 * @return {string}
 */ proto.IM.Call.CallLifecycleResult.prototype.getDetailCode = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.setDetailCode = function(value) {
    return jspb.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.clearDetailCode = function() {
    return jspb.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallLifecycleResult.prototype.hasDetailCode = function() {
    return jspb.Message.getField(this, 9) != null;
};
/**
 * optional uint32 initiator_user_id = 10;
 * @return {number}
 */ proto.IM.Call.CallLifecycleResult.prototype.getInitiatorUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.setInitiatorUserId = function(value) {
    return jspb.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.clearInitiatorUserId = function() {
    return jspb.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallLifecycleResult.prototype.hasInitiatorUserId = function() {
    return jspb.Message.getField(this, 10) != null;
};
/**
 * optional uint32 invitee_user_id = 11;
 * @return {number}
 */ proto.IM.Call.CallLifecycleResult.prototype.getInviteeUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.setInviteeUserId = function(value) {
    return jspb.Message.setField(this, 11, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.clearInviteeUserId = function() {
    return jspb.Message.setField(this, 11, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallLifecycleResult.prototype.hasInviteeUserId = function() {
    return jspb.Message.getField(this, 11) != null;
};
/**
 * optional CallMediaKind media_kind = 12;
 * @return {!proto.IM.Call.CallMediaKind}
 */ proto.IM.Call.CallLifecycleResult.prototype.getMediaKind = function() {
    return /** @type {!proto.IM.Call.CallMediaKind} */ jspb.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {!proto.IM.Call.CallMediaKind} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.setMediaKind = function(value) {
    return jspb.Message.setField(this, 12, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.clearMediaKind = function() {
    return jspb.Message.setField(this, 12, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallLifecycleResult.prototype.hasMediaKind = function() {
    return jspb.Message.getField(this, 12) != null;
};
/**
 * optional CallLifecycleState lifecycle_state = 13;
 * @return {!proto.IM.Call.CallLifecycleState}
 */ proto.IM.Call.CallLifecycleResult.prototype.getLifecycleState = function() {
    return /** @type {!proto.IM.Call.CallLifecycleState} */ jspb.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {!proto.IM.Call.CallLifecycleState} value
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.setLifecycleState = function(value) {
    return jspb.Message.setField(this, 13, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallLifecycleResult} returns this
 */ proto.IM.Call.CallLifecycleResult.prototype.clearLifecycleState = function() {
    return jspb.Message.setField(this, 13, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallLifecycleResult.prototype.hasLifecycleState = function() {
    return jspb.Message.getField(this, 13) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.CallParticipantTerminalSnapshot.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.CallParticipantTerminalSnapshot.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.CallParticipantTerminalSnapshot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallParticipantTerminalSnapshot.toObject = function(includeInstance, msg) {
        var f, obj = {
            identity: (f = msg.getIdentity()) && IM_BaseDefine_pb.UserIdentityRef.toObject(includeInstance, f),
            role: jspb.Message.getFieldWithDefault(msg, 2, 0),
            outcome: jspb.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.CallParticipantTerminalSnapshot}
 */ proto.IM.Call.CallParticipantTerminalSnapshot.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.CallParticipantTerminalSnapshot;
    return proto.IM.Call.CallParticipantTerminalSnapshot.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.CallParticipantTerminalSnapshot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.CallParticipantTerminalSnapshot}
 */ proto.IM.Call.CallParticipantTerminalSnapshot.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new IM_BaseDefine_pb.UserIdentityRef;
                reader.readMessage(value, IM_BaseDefine_pb.UserIdentityRef.deserializeBinaryFromReader);
                msg.setIdentity(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.Call.CallParticipantRole} */ reader.readEnum();
                msg.setRole(value);
                break;
            case 3:
                var value = /** @type {!proto.IM.Call.CallParticipantOutcome} */ reader.readEnum();
                msg.setOutcome(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.CallParticipantTerminalSnapshot.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.CallParticipantTerminalSnapshot.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.CallParticipantTerminalSnapshot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallParticipantTerminalSnapshot.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getIdentity();
    if (f != null) {
        writer.writeMessage(1, f, IM_BaseDefine_pb.UserIdentityRef.serializeBinaryToWriter);
    }
    f = message.getRole();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
    f = message.getOutcome();
    if (f !== 0.0) {
        writer.writeEnum(3, f);
    }
};
/**
 * optional IM.BaseDefine.UserIdentityRef identity = 1;
 * @return {?proto.IM.BaseDefine.UserIdentityRef}
 */ proto.IM.Call.CallParticipantTerminalSnapshot.prototype.getIdentity = function() {
    return /** @type{?proto.IM.BaseDefine.UserIdentityRef} */ jspb.Message.getWrapperField(this, IM_BaseDefine_pb.UserIdentityRef, 1);
};
/**
 * @param {?proto.IM.BaseDefine.UserIdentityRef|undefined} value
 * @return {!proto.IM.Call.CallParticipantTerminalSnapshot} returns this
*/ proto.IM.Call.CallParticipantTerminalSnapshot.prototype.setIdentity = function(value) {
    return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.IM.Call.CallParticipantTerminalSnapshot} returns this
 */ proto.IM.Call.CallParticipantTerminalSnapshot.prototype.clearIdentity = function() {
    return this.setIdentity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallParticipantTerminalSnapshot.prototype.hasIdentity = function() {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional CallParticipantRole role = 2;
 * @return {!proto.IM.Call.CallParticipantRole}
 */ proto.IM.Call.CallParticipantTerminalSnapshot.prototype.getRole = function() {
    return /** @type {!proto.IM.Call.CallParticipantRole} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.Call.CallParticipantRole} value
 * @return {!proto.IM.Call.CallParticipantTerminalSnapshot} returns this
 */ proto.IM.Call.CallParticipantTerminalSnapshot.prototype.setRole = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional CallParticipantOutcome outcome = 3;
 * @return {!proto.IM.Call.CallParticipantOutcome}
 */ proto.IM.Call.CallParticipantTerminalSnapshot.prototype.getOutcome = function() {
    return /** @type {!proto.IM.Call.CallParticipantOutcome} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.IM.Call.CallParticipantOutcome} value
 * @return {!proto.IM.Call.CallParticipantTerminalSnapshot} returns this
 */ proto.IM.Call.CallParticipantTerminalSnapshot.prototype.setOutcome = function(value) {
    return jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.IM.Call.CallTerminalFact.repeatedFields_ = [
    12
];
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.CallTerminalFact.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.CallTerminalFact.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.CallTerminalFact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallTerminalFact.toObject = function(includeInstance, msg) {
        var f, obj = {
            schemaVersion: jspb.Message.getFieldWithDefault(msg, 1, 0),
            eventId: msg.getEventId_asB64(),
            callId: msg.getCallId_asB64(),
            sessionId: msg.getSessionId_asB64(),
            aggregateVersion: jspb.Message.getFieldWithDefault(msg, 5, 0),
            relationId: jspb.Message.getFieldWithDefault(msg, 6, 0),
            scope: jspb.Message.getFieldWithDefault(msg, 7, 0),
            mediaKind: jspb.Message.getFieldWithDefault(msg, 8, 0),
            terminalOutcome: jspb.Message.getFieldWithDefault(msg, 9, 0),
            initiatorUserId: jspb.Message.getFieldWithDefault(msg, 10, 0),
            inviteeUserId: jspb.Message.getFieldWithDefault(msg, 11, 0),
            participantsList: jspb.Message.toObjectList(msg.getParticipantsList(), proto.IM.Call.CallParticipantTerminalSnapshot.toObject, includeInstance),
            endedAtMs: jspb.Message.getFieldWithDefault(msg, 13, 0),
            connectedAtMs: jspb.Message.getFieldWithDefault(msg, 14, 0),
            durationMs: jspb.Message.getFieldWithDefault(msg, 15, 0),
            diagnosticReason: jspb.Message.getFieldWithDefault(msg, 16, ""),
            groupId: jspb.Message.getFieldWithDefault(msg, 17, 0),
            groupVersion: jspb.Message.getFieldWithDefault(msg, 18, 0),
            groupNameSnapshot: jspb.Message.getFieldWithDefault(msg, 19, ""),
            groupAvatarAssetIdSnapshot: jspb.Message.getFieldWithDefault(msg, 20, ""),
            joinedParticipantCount: jspb.Message.getFieldWithDefault(msg, 21, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.CallTerminalFact}
 */ proto.IM.Call.CallTerminalFact.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.CallTerminalFact;
    return proto.IM.Call.CallTerminalFact.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.CallTerminalFact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.CallTerminalFact}
 */ proto.IM.Call.CallTerminalFact.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSchemaVersion(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setEventId(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCallId(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSessionId(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint64();
                msg.setAggregateVersion(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint32();
                msg.setRelationId(value);
                break;
            case 7:
                var value = /** @type {!proto.IM.Call.CallScope} */ reader.readEnum();
                msg.setScope(value);
                break;
            case 8:
                var value = /** @type {!proto.IM.Call.CallMediaKind} */ reader.readEnum();
                msg.setMediaKind(value);
                break;
            case 9:
                var value = /** @type {!proto.IM.Call.CallTerminalOutcome} */ reader.readEnum();
                msg.setTerminalOutcome(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readUint32();
                msg.setInitiatorUserId(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readUint32();
                msg.setInviteeUserId(value);
                break;
            case 12:
                var value = new proto.IM.Call.CallParticipantTerminalSnapshot;
                reader.readMessage(value, proto.IM.Call.CallParticipantTerminalSnapshot.deserializeBinaryFromReader);
                msg.addParticipants(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readUint64();
                msg.setEndedAtMs(value);
                break;
            case 14:
                var value = /** @type {number} */ reader.readUint64();
                msg.setConnectedAtMs(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readUint64();
                msg.setDurationMs(value);
                break;
            case 16:
                var value = /** @type {string} */ reader.readString();
                msg.setDiagnosticReason(value);
                break;
            case 17:
                var value = /** @type {number} */ reader.readUint32();
                msg.setGroupId(value);
                break;
            case 18:
                var value = /** @type {number} */ reader.readUint64();
                msg.setGroupVersion(value);
                break;
            case 19:
                var value = /** @type {string} */ reader.readString();
                msg.setGroupNameSnapshot(value);
                break;
            case 20:
                var value = /** @type {string} */ reader.readString();
                msg.setGroupAvatarAssetIdSnapshot(value);
                break;
            case 21:
                var value = /** @type {number} */ reader.readUint32();
                msg.setJoinedParticipantCount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.CallTerminalFact.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.CallTerminalFact.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.CallTerminalFact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallTerminalFact.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSchemaVersion();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getEventId_asU8();
    if (f.length > 0) {
        writer.writeBytes(2, f);
    }
    f = message.getCallId_asU8();
    if (f.length > 0) {
        writer.writeBytes(3, f);
    }
    f = message.getSessionId_asU8();
    if (f.length > 0) {
        writer.writeBytes(4, f);
    }
    f = message.getAggregateVersion();
    if (f !== 0) {
        writer.writeUint64(5, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 6);
    if (f != null) {
        writer.writeUint32(6, f);
    }
    f = message.getScope();
    if (f !== 0.0) {
        writer.writeEnum(7, f);
    }
    f = message.getMediaKind();
    if (f !== 0.0) {
        writer.writeEnum(8, f);
    }
    f = message.getTerminalOutcome();
    if (f !== 0.0) {
        writer.writeEnum(9, f);
    }
    f = message.getInitiatorUserId();
    if (f !== 0) {
        writer.writeUint32(10, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 11);
    if (f != null) {
        writer.writeUint32(11, f);
    }
    f = message.getParticipantsList();
    if (f.length > 0) {
        writer.writeRepeatedMessage(12, f, proto.IM.Call.CallParticipantTerminalSnapshot.serializeBinaryToWriter);
    }
    f = message.getEndedAtMs();
    if (f !== 0) {
        writer.writeUint64(13, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 14);
    if (f != null) {
        writer.writeUint64(14, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 15);
    if (f != null) {
        writer.writeUint64(15, f);
    }
    f = /** @type {string} */ jspb.Message.getField(message, 16);
    if (f != null) {
        writer.writeString(16, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 17);
    if (f != null) {
        writer.writeUint32(17, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 18);
    if (f != null) {
        writer.writeUint64(18, f);
    }
    f = /** @type {string} */ jspb.Message.getField(message, 19);
    if (f != null) {
        writer.writeString(19, f);
    }
    f = /** @type {string} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeString(20, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 21);
    if (f != null) {
        writer.writeUint32(21, f);
    }
};
/**
 * optional uint32 schema_version = 1;
 * @return {number}
 */ proto.IM.Call.CallTerminalFact.prototype.getSchemaVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setSchemaVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional bytes event_id = 2;
 * @return {string}
 */ proto.IM.Call.CallTerminalFact.prototype.getEventId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes event_id = 2;
 * This is a type-conversion wrapper around `getEventId()`
 * @return {string}
 */ proto.IM.Call.CallTerminalFact.prototype.getEventId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getEventId());
};
/**
 * optional bytes event_id = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEventId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallTerminalFact.prototype.getEventId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getEventId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setEventId = function(value) {
    return jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional bytes call_id = 3;
 * @return {string}
 */ proto.IM.Call.CallTerminalFact.prototype.getCallId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes call_id = 3;
 * This is a type-conversion wrapper around `getCallId()`
 * @return {string}
 */ proto.IM.Call.CallTerminalFact.prototype.getCallId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCallId());
};
/**
 * optional bytes call_id = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallTerminalFact.prototype.getCallId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCallId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setCallId = function(value) {
    return jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional bytes session_id = 4;
 * @return {string}
 */ proto.IM.Call.CallTerminalFact.prototype.getSessionId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes session_id = 4;
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {string}
 */ proto.IM.Call.CallTerminalFact.prototype.getSessionId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getSessionId());
};
/**
 * optional bytes session_id = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSessionId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallTerminalFact.prototype.getSessionId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getSessionId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3BytesField(this, 4, value);
};
/**
 * optional uint64 aggregate_version = 5;
 * @return {number}
 */ proto.IM.Call.CallTerminalFact.prototype.getAggregateVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setAggregateVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional uint32 relation_id = 6;
 * @return {number}
 */ proto.IM.Call.CallTerminalFact.prototype.getRelationId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setRelationId = function(value) {
    return jspb.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.clearRelationId = function() {
    return jspb.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallTerminalFact.prototype.hasRelationId = function() {
    return jspb.Message.getField(this, 6) != null;
};
/**
 * optional CallScope scope = 7;
 * @return {!proto.IM.Call.CallScope}
 */ proto.IM.Call.CallTerminalFact.prototype.getScope = function() {
    return /** @type {!proto.IM.Call.CallScope} */ jspb.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {!proto.IM.Call.CallScope} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setScope = function(value) {
    return jspb.Message.setProto3EnumField(this, 7, value);
};
/**
 * optional CallMediaKind media_kind = 8;
 * @return {!proto.IM.Call.CallMediaKind}
 */ proto.IM.Call.CallTerminalFact.prototype.getMediaKind = function() {
    return /** @type {!proto.IM.Call.CallMediaKind} */ jspb.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {!proto.IM.Call.CallMediaKind} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setMediaKind = function(value) {
    return jspb.Message.setProto3EnumField(this, 8, value);
};
/**
 * optional CallTerminalOutcome terminal_outcome = 9;
 * @return {!proto.IM.Call.CallTerminalOutcome}
 */ proto.IM.Call.CallTerminalFact.prototype.getTerminalOutcome = function() {
    return /** @type {!proto.IM.Call.CallTerminalOutcome} */ jspb.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {!proto.IM.Call.CallTerminalOutcome} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setTerminalOutcome = function(value) {
    return jspb.Message.setProto3EnumField(this, 9, value);
};
/**
 * optional uint32 initiator_user_id = 10;
 * @return {number}
 */ proto.IM.Call.CallTerminalFact.prototype.getInitiatorUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setInitiatorUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 10, value);
};
/**
 * optional uint32 invitee_user_id = 11;
 * @return {number}
 */ proto.IM.Call.CallTerminalFact.prototype.getInviteeUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setInviteeUserId = function(value) {
    return jspb.Message.setField(this, 11, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.clearInviteeUserId = function() {
    return jspb.Message.setField(this, 11, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallTerminalFact.prototype.hasInviteeUserId = function() {
    return jspb.Message.getField(this, 11) != null;
};
/**
 * repeated CallParticipantTerminalSnapshot participants = 12;
 * @return {!Array<!proto.IM.Call.CallParticipantTerminalSnapshot>}
 */ proto.IM.Call.CallTerminalFact.prototype.getParticipantsList = function() {
    return /** @type{!Array<!proto.IM.Call.CallParticipantTerminalSnapshot>} */ jspb.Message.getRepeatedWrapperField(this, proto.IM.Call.CallParticipantTerminalSnapshot, 12);
};
/**
 * @param {!Array<!proto.IM.Call.CallParticipantTerminalSnapshot>} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
*/ proto.IM.Call.CallTerminalFact.prototype.setParticipantsList = function(value) {
    return jspb.Message.setRepeatedWrapperField(this, 12, value);
};
/**
 * @param {!proto.IM.Call.CallParticipantTerminalSnapshot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.IM.Call.CallParticipantTerminalSnapshot}
 */ proto.IM.Call.CallTerminalFact.prototype.addParticipants = function(opt_value, opt_index) {
    return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.IM.Call.CallParticipantTerminalSnapshot, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.clearParticipantsList = function() {
    return this.setParticipantsList([]);
};
/**
 * optional uint64 ended_at_ms = 13;
 * @return {number}
 */ proto.IM.Call.CallTerminalFact.prototype.getEndedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setEndedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 13, value);
};
/**
 * optional uint64 connected_at_ms = 14;
 * @return {number}
 */ proto.IM.Call.CallTerminalFact.prototype.getConnectedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 14, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setConnectedAtMs = function(value) {
    return jspb.Message.setField(this, 14, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.clearConnectedAtMs = function() {
    return jspb.Message.setField(this, 14, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallTerminalFact.prototype.hasConnectedAtMs = function() {
    return jspb.Message.getField(this, 14) != null;
};
/**
 * optional uint64 duration_ms = 15;
 * @return {number}
 */ proto.IM.Call.CallTerminalFact.prototype.getDurationMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setDurationMs = function(value) {
    return jspb.Message.setField(this, 15, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.clearDurationMs = function() {
    return jspb.Message.setField(this, 15, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallTerminalFact.prototype.hasDurationMs = function() {
    return jspb.Message.getField(this, 15) != null;
};
/**
 * optional string diagnostic_reason = 16;
 * @return {string}
 */ proto.IM.Call.CallTerminalFact.prototype.getDiagnosticReason = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 16, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setDiagnosticReason = function(value) {
    return jspb.Message.setField(this, 16, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.clearDiagnosticReason = function() {
    return jspb.Message.setField(this, 16, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallTerminalFact.prototype.hasDiagnosticReason = function() {
    return jspb.Message.getField(this, 16) != null;
};
/**
 * optional uint32 group_id = 17;
 * @return {number}
 */ proto.IM.Call.CallTerminalFact.prototype.getGroupId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 17, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setGroupId = function(value) {
    return jspb.Message.setField(this, 17, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.clearGroupId = function() {
    return jspb.Message.setField(this, 17, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallTerminalFact.prototype.hasGroupId = function() {
    return jspb.Message.getField(this, 17) != null;
};
/**
 * optional uint64 group_version = 18;
 * @return {number}
 */ proto.IM.Call.CallTerminalFact.prototype.getGroupVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 18, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setGroupVersion = function(value) {
    return jspb.Message.setField(this, 18, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.clearGroupVersion = function() {
    return jspb.Message.setField(this, 18, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallTerminalFact.prototype.hasGroupVersion = function() {
    return jspb.Message.getField(this, 18) != null;
};
/**
 * optional string group_name_snapshot = 19;
 * @return {string}
 */ proto.IM.Call.CallTerminalFact.prototype.getGroupNameSnapshot = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 19, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setGroupNameSnapshot = function(value) {
    return jspb.Message.setField(this, 19, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.clearGroupNameSnapshot = function() {
    return jspb.Message.setField(this, 19, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallTerminalFact.prototype.hasGroupNameSnapshot = function() {
    return jspb.Message.getField(this, 19) != null;
};
/**
 * optional string group_avatar_asset_id_snapshot = 20;
 * @return {string}
 */ proto.IM.Call.CallTerminalFact.prototype.getGroupAvatarAssetIdSnapshot = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setGroupAvatarAssetIdSnapshot = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.clearGroupAvatarAssetIdSnapshot = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallTerminalFact.prototype.hasGroupAvatarAssetIdSnapshot = function() {
    return jspb.Message.getField(this, 20) != null;
};
/**
 * optional uint32 joined_participant_count = 21;
 * @return {number}
 */ proto.IM.Call.CallTerminalFact.prototype.getJoinedParticipantCount = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 21, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.setJoinedParticipantCount = function(value) {
    return jspb.Message.setField(this, 21, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallTerminalFact} returns this
 */ proto.IM.Call.CallTerminalFact.prototype.clearJoinedParticipantCount = function() {
    return jspb.Message.setField(this, 21, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallTerminalFact.prototype.hasJoinedParticipantCount = function() {
    return jspb.Message.getField(this, 21) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.IM.Call.CallMessageContent.repeatedFields_ = [
    9
];
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.CallMessageContent.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.CallMessageContent.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.CallMessageContent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallMessageContent.toObject = function(includeInstance, msg) {
        var f, obj = {
            schemaVersion: jspb.Message.getFieldWithDefault(msg, 1, 0),
            callId: msg.getCallId_asB64(),
            relationId: jspb.Message.getFieldWithDefault(msg, 3, 0),
            scope: jspb.Message.getFieldWithDefault(msg, 4, 0),
            mediaKind: jspb.Message.getFieldWithDefault(msg, 5, 0),
            terminalOutcome: jspb.Message.getFieldWithDefault(msg, 6, 0),
            initiatorUserId: jspb.Message.getFieldWithDefault(msg, 7, 0),
            inviteeUserId: jspb.Message.getFieldWithDefault(msg, 8, 0),
            participantsList: jspb.Message.toObjectList(msg.getParticipantsList(), proto.IM.Call.CallParticipantTerminalSnapshot.toObject, includeInstance),
            endedAtMs: jspb.Message.getFieldWithDefault(msg, 10, 0),
            durationMs: jspb.Message.getFieldWithDefault(msg, 11, 0),
            groupId: jspb.Message.getFieldWithDefault(msg, 12, 0),
            groupNameSnapshot: jspb.Message.getFieldWithDefault(msg, 13, ""),
            groupAvatarAssetIdSnapshot: jspb.Message.getFieldWithDefault(msg, 14, ""),
            joinedParticipantCount: jspb.Message.getFieldWithDefault(msg, 15, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.CallMessageContent}
 */ proto.IM.Call.CallMessageContent.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.CallMessageContent;
    return proto.IM.Call.CallMessageContent.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.CallMessageContent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.CallMessageContent}
 */ proto.IM.Call.CallMessageContent.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSchemaVersion(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCallId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setRelationId(value);
                break;
            case 4:
                var value = /** @type {!proto.IM.Call.CallScope} */ reader.readEnum();
                msg.setScope(value);
                break;
            case 5:
                var value = /** @type {!proto.IM.Call.CallMediaKind} */ reader.readEnum();
                msg.setMediaKind(value);
                break;
            case 6:
                var value = /** @type {!proto.IM.Call.CallTerminalOutcome} */ reader.readEnum();
                msg.setTerminalOutcome(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readUint32();
                msg.setInitiatorUserId(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setInviteeUserId(value);
                break;
            case 9:
                var value = new proto.IM.Call.CallParticipantTerminalSnapshot;
                reader.readMessage(value, proto.IM.Call.CallParticipantTerminalSnapshot.deserializeBinaryFromReader);
                msg.addParticipants(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readUint64();
                msg.setEndedAtMs(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readUint64();
                msg.setDurationMs(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readUint32();
                msg.setGroupId(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setGroupNameSnapshot(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setGroupAvatarAssetIdSnapshot(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readUint32();
                msg.setJoinedParticipantCount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.CallMessageContent.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.CallMessageContent.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.CallMessageContent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.CallMessageContent.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSchemaVersion();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getCallId_asU8();
    if (f.length > 0) {
        writer.writeBytes(2, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 3);
    if (f != null) {
        writer.writeUint32(3, f);
    }
    f = message.getScope();
    if (f !== 0.0) {
        writer.writeEnum(4, f);
    }
    f = message.getMediaKind();
    if (f !== 0.0) {
        writer.writeEnum(5, f);
    }
    f = message.getTerminalOutcome();
    if (f !== 0.0) {
        writer.writeEnum(6, f);
    }
    f = message.getInitiatorUserId();
    if (f !== 0) {
        writer.writeUint32(7, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 8);
    if (f != null) {
        writer.writeUint32(8, f);
    }
    f = message.getParticipantsList();
    if (f.length > 0) {
        writer.writeRepeatedMessage(9, f, proto.IM.Call.CallParticipantTerminalSnapshot.serializeBinaryToWriter);
    }
    f = message.getEndedAtMs();
    if (f !== 0) {
        writer.writeUint64(10, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 11);
    if (f != null) {
        writer.writeUint64(11, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 12);
    if (f != null) {
        writer.writeUint32(12, f);
    }
    f = /** @type {string} */ jspb.Message.getField(message, 13);
    if (f != null) {
        writer.writeString(13, f);
    }
    f = /** @type {string} */ jspb.Message.getField(message, 14);
    if (f != null) {
        writer.writeString(14, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 15);
    if (f != null) {
        writer.writeUint32(15, f);
    }
};
/**
 * optional uint32 schema_version = 1;
 * @return {number}
 */ proto.IM.Call.CallMessageContent.prototype.getSchemaVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setSchemaVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional bytes call_id = 2;
 * @return {string}
 */ proto.IM.Call.CallMessageContent.prototype.getCallId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes call_id = 2;
 * This is a type-conversion wrapper around `getCallId()`
 * @return {string}
 */ proto.IM.Call.CallMessageContent.prototype.getCallId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCallId());
};
/**
 * optional bytes call_id = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.CallMessageContent.prototype.getCallId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCallId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setCallId = function(value) {
    return jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional uint32 relation_id = 3;
 * @return {number}
 */ proto.IM.Call.CallMessageContent.prototype.getRelationId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setRelationId = function(value) {
    return jspb.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.clearRelationId = function() {
    return jspb.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallMessageContent.prototype.hasRelationId = function() {
    return jspb.Message.getField(this, 3) != null;
};
/**
 * optional CallScope scope = 4;
 * @return {!proto.IM.Call.CallScope}
 */ proto.IM.Call.CallMessageContent.prototype.getScope = function() {
    return /** @type {!proto.IM.Call.CallScope} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.IM.Call.CallScope} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setScope = function(value) {
    return jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional CallMediaKind media_kind = 5;
 * @return {!proto.IM.Call.CallMediaKind}
 */ proto.IM.Call.CallMessageContent.prototype.getMediaKind = function() {
    return /** @type {!proto.IM.Call.CallMediaKind} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.IM.Call.CallMediaKind} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setMediaKind = function(value) {
    return jspb.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional CallTerminalOutcome terminal_outcome = 6;
 * @return {!proto.IM.Call.CallTerminalOutcome}
 */ proto.IM.Call.CallMessageContent.prototype.getTerminalOutcome = function() {
    return /** @type {!proto.IM.Call.CallTerminalOutcome} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.IM.Call.CallTerminalOutcome} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setTerminalOutcome = function(value) {
    return jspb.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional uint32 initiator_user_id = 7;
 * @return {number}
 */ proto.IM.Call.CallMessageContent.prototype.getInitiatorUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setInitiatorUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * optional uint32 invitee_user_id = 8;
 * @return {number}
 */ proto.IM.Call.CallMessageContent.prototype.getInviteeUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setInviteeUserId = function(value) {
    return jspb.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.clearInviteeUserId = function() {
    return jspb.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallMessageContent.prototype.hasInviteeUserId = function() {
    return jspb.Message.getField(this, 8) != null;
};
/**
 * repeated CallParticipantTerminalSnapshot participants = 9;
 * @return {!Array<!proto.IM.Call.CallParticipantTerminalSnapshot>}
 */ proto.IM.Call.CallMessageContent.prototype.getParticipantsList = function() {
    return /** @type{!Array<!proto.IM.Call.CallParticipantTerminalSnapshot>} */ jspb.Message.getRepeatedWrapperField(this, proto.IM.Call.CallParticipantTerminalSnapshot, 9);
};
/**
 * @param {!Array<!proto.IM.Call.CallParticipantTerminalSnapshot>} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
*/ proto.IM.Call.CallMessageContent.prototype.setParticipantsList = function(value) {
    return jspb.Message.setRepeatedWrapperField(this, 9, value);
};
/**
 * @param {!proto.IM.Call.CallParticipantTerminalSnapshot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.IM.Call.CallParticipantTerminalSnapshot}
 */ proto.IM.Call.CallMessageContent.prototype.addParticipants = function(opt_value, opt_index) {
    return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.IM.Call.CallParticipantTerminalSnapshot, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.clearParticipantsList = function() {
    return this.setParticipantsList([]);
};
/**
 * optional uint64 ended_at_ms = 10;
 * @return {number}
 */ proto.IM.Call.CallMessageContent.prototype.getEndedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setEndedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 10, value);
};
/**
 * optional uint64 duration_ms = 11;
 * @return {number}
 */ proto.IM.Call.CallMessageContent.prototype.getDurationMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setDurationMs = function(value) {
    return jspb.Message.setField(this, 11, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.clearDurationMs = function() {
    return jspb.Message.setField(this, 11, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallMessageContent.prototype.hasDurationMs = function() {
    return jspb.Message.getField(this, 11) != null;
};
/**
 * optional uint32 group_id = 12;
 * @return {number}
 */ proto.IM.Call.CallMessageContent.prototype.getGroupId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setGroupId = function(value) {
    return jspb.Message.setField(this, 12, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.clearGroupId = function() {
    return jspb.Message.setField(this, 12, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallMessageContent.prototype.hasGroupId = function() {
    return jspb.Message.getField(this, 12) != null;
};
/**
 * optional string group_name_snapshot = 13;
 * @return {string}
 */ proto.IM.Call.CallMessageContent.prototype.getGroupNameSnapshot = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setGroupNameSnapshot = function(value) {
    return jspb.Message.setField(this, 13, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.clearGroupNameSnapshot = function() {
    return jspb.Message.setField(this, 13, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallMessageContent.prototype.hasGroupNameSnapshot = function() {
    return jspb.Message.getField(this, 13) != null;
};
/**
 * optional string group_avatar_asset_id_snapshot = 14;
 * @return {string}
 */ proto.IM.Call.CallMessageContent.prototype.getGroupAvatarAssetIdSnapshot = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setGroupAvatarAssetIdSnapshot = function(value) {
    return jspb.Message.setField(this, 14, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.clearGroupAvatarAssetIdSnapshot = function() {
    return jspb.Message.setField(this, 14, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallMessageContent.prototype.hasGroupAvatarAssetIdSnapshot = function() {
    return jspb.Message.getField(this, 14) != null;
};
/**
 * optional uint32 joined_participant_count = 15;
 * @return {number}
 */ proto.IM.Call.CallMessageContent.prototype.getJoinedParticipantCount = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.setJoinedParticipantCount = function(value) {
    return jspb.Message.setField(this, 15, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.CallMessageContent} returns this
 */ proto.IM.Call.CallMessageContent.prototype.clearJoinedParticipantCount = function() {
    return jspb.Message.setField(this, 15, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.CallMessageContent.prototype.hasJoinedParticipantCount = function() {
    return jspb.Message.getField(this, 15) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.IMCallProjectionReq.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.IMCallProjectionReq.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.IMCallProjectionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.IMCallProjectionReq.toObject = function(includeInstance, msg) {
        var f, obj = {
            projectionKind: jspb.Message.getFieldWithDefault(msg, 1, 0),
            terminalFact: (f = msg.getTerminalFact()) && proto.IM.Call.CallTerminalFact.toObject(includeInstance, f),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.IMCallProjectionReq}
 */ proto.IM.Call.IMCallProjectionReq.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.IMCallProjectionReq;
    return proto.IM.Call.IMCallProjectionReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.IMCallProjectionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.IMCallProjectionReq}
 */ proto.IM.Call.IMCallProjectionReq.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.IM.Call.CallProjectionKind} */ reader.readEnum();
                msg.setProjectionKind(value);
                break;
            case 2:
                var value = new proto.IM.Call.CallTerminalFact;
                reader.readMessage(value, proto.IM.Call.CallTerminalFact.deserializeBinaryFromReader);
                msg.setTerminalFact(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.IMCallProjectionReq.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.IMCallProjectionReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.IMCallProjectionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.IMCallProjectionReq.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProjectionKind();
    if (f !== 0.0) {
        writer.writeEnum(1, f);
    }
    f = message.getTerminalFact();
    if (f != null) {
        writer.writeMessage(2, f, proto.IM.Call.CallTerminalFact.serializeBinaryToWriter);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional CallProjectionKind projection_kind = 1;
 * @return {!proto.IM.Call.CallProjectionKind}
 */ proto.IM.Call.IMCallProjectionReq.prototype.getProjectionKind = function() {
    return /** @type {!proto.IM.Call.CallProjectionKind} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.IM.Call.CallProjectionKind} value
 * @return {!proto.IM.Call.IMCallProjectionReq} returns this
 */ proto.IM.Call.IMCallProjectionReq.prototype.setProjectionKind = function(value) {
    return jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional CallTerminalFact terminal_fact = 2;
 * @return {?proto.IM.Call.CallTerminalFact}
 */ proto.IM.Call.IMCallProjectionReq.prototype.getTerminalFact = function() {
    return /** @type{?proto.IM.Call.CallTerminalFact} */ jspb.Message.getWrapperField(this, proto.IM.Call.CallTerminalFact, 2);
};
/**
 * @param {?proto.IM.Call.CallTerminalFact|undefined} value
 * @return {!proto.IM.Call.IMCallProjectionReq} returns this
*/ proto.IM.Call.IMCallProjectionReq.prototype.setTerminalFact = function(value) {
    return jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.IM.Call.IMCallProjectionReq} returns this
 */ proto.IM.Call.IMCallProjectionReq.prototype.clearTerminalFact = function() {
    return this.setTerminalFact(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.IMCallProjectionReq.prototype.hasTerminalFact = function() {
    return jspb.Message.getField(this, 2) != null;
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Call.IMCallProjectionReq.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Call.IMCallProjectionReq.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Call.IMCallProjectionReq.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.IMCallProjectionReq} returns this
 */ proto.IM.Call.IMCallProjectionReq.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.IMCallProjectionReq} returns this
 */ proto.IM.Call.IMCallProjectionReq.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.IMCallProjectionReq.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Call.IMCallProjectionRsp.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Call.IMCallProjectionRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.IMCallProjectionRsp.toObject = function(includeInstance, msg) {
        var f, obj = {
            resultCode: jspb.Message.getFieldWithDefault(msg, 1, 0),
            eventId: msg.getEventId_asB64(),
            callId: msg.getCallId_asB64(),
            projectionKind: jspb.Message.getFieldWithDefault(msg, 4, 0),
            relationId: jspb.Message.getFieldWithDefault(msg, 5, 0),
            msgId: jspb.Message.getFieldWithDefault(msg, 6, 0),
            msgType: jspb.Message.getFieldWithDefault(msg, 7, 0),
            messageShard: jspb.Message.getFieldWithDefault(msg, 8, 0),
            messageContent: msg.getMessageContent_asB64(),
            unreadUserId: jspb.Message.getFieldWithDefault(msg, 10, 0),
            createdAtMs: jspb.Message.getFieldWithDefault(msg, 11, 0),
            attachData: msg.getAttachData_asB64(),
            groupId: jspb.Message.getFieldWithDefault(msg, 21, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Call.IMCallProjectionRsp}
 */ proto.IM.Call.IMCallProjectionRsp.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Call.IMCallProjectionRsp;
    return proto.IM.Call.IMCallProjectionRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Call.IMCallProjectionRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Call.IMCallProjectionRsp}
 */ proto.IM.Call.IMCallProjectionRsp.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.IM.Call.CallResultCode} */ reader.readEnum();
                msg.setResultCode(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setEventId(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setCallId(value);
                break;
            case 4:
                var value = /** @type {!proto.IM.Call.CallProjectionKind} */ reader.readEnum();
                msg.setProjectionKind(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setRelationId(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMsgId(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMsgType(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMessageShard(value);
                break;
            case 9:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMessageContent(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUnreadUserId(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readUint64();
                msg.setCreatedAtMs(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            case 21:
                var value = /** @type {number} */ reader.readUint32();
                msg.setGroupId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Call.IMCallProjectionRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Call.IMCallProjectionRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Call.IMCallProjectionRsp.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getResultCode();
    if (f !== 0.0) {
        writer.writeEnum(1, f);
    }
    f = message.getEventId_asU8();
    if (f.length > 0) {
        writer.writeBytes(2, f);
    }
    f = message.getCallId_asU8();
    if (f.length > 0) {
        writer.writeBytes(3, f);
    }
    f = message.getProjectionKind();
    if (f !== 0.0) {
        writer.writeEnum(4, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 5);
    if (f != null) {
        writer.writeUint32(5, f);
    }
    f = message.getMsgId();
    if (f !== 0) {
        writer.writeUint32(6, f);
    }
    f = message.getMsgType();
    if (f !== 0) {
        writer.writeUint32(7, f);
    }
    f = message.getMessageShard();
    if (f !== 0) {
        writer.writeUint32(8, f);
    }
    f = message.getMessageContent_asU8();
    if (f.length > 0) {
        writer.writeBytes(9, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 10);
    if (f != null) {
        writer.writeUint32(10, f);
    }
    f = message.getCreatedAtMs();
    if (f !== 0) {
        writer.writeUint64(11, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
    f = /** @type {number} */ jspb.Message.getField(message, 21);
    if (f != null) {
        writer.writeUint32(21, f);
    }
};
/**
 * optional CallResultCode result_code = 1;
 * @return {!proto.IM.Call.CallResultCode}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getResultCode = function() {
    return /** @type {!proto.IM.Call.CallResultCode} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.IM.Call.CallResultCode} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setResultCode = function(value) {
    return jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional bytes event_id = 2;
 * @return {string}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getEventId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes event_id = 2;
 * This is a type-conversion wrapper around `getEventId()`
 * @return {string}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getEventId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getEventId());
};
/**
 * optional bytes event_id = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEventId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getEventId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getEventId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setEventId = function(value) {
    return jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional bytes call_id = 3;
 * @return {string}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getCallId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes call_id = 3;
 * This is a type-conversion wrapper around `getCallId()`
 * @return {string}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getCallId_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getCallId());
};
/**
 * optional bytes call_id = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallId()`
 * @return {!Uint8Array}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getCallId_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getCallId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setCallId = function(value) {
    return jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional CallProjectionKind projection_kind = 4;
 * @return {!proto.IM.Call.CallProjectionKind}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getProjectionKind = function() {
    return /** @type {!proto.IM.Call.CallProjectionKind} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.IM.Call.CallProjectionKind} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setProjectionKind = function(value) {
    return jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional uint32 relation_id = 5;
 * @return {number}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getRelationId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setRelationId = function(value) {
    return jspb.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.clearRelationId = function() {
    return jspb.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.hasRelationId = function() {
    return jspb.Message.getField(this, 5) != null;
};
/**
 * optional uint32 msg_id = 6;
 * @return {number}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getMsgId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setMsgId = function(value) {
    return jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional uint32 msg_type = 7;
 * @return {number}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getMsgType = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setMsgType = function(value) {
    return jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * optional uint32 message_shard = 8;
 * @return {number}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getMessageShard = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setMessageShard = function(value) {
    return jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * optional bytes message_content = 9;
 * @return {string}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getMessageContent = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 9, "");
};
/**
 * optional bytes message_content = 9;
 * This is a type-conversion wrapper around `getMessageContent()`
 * @return {string}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getMessageContent_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getMessageContent());
};
/**
 * optional bytes message_content = 9;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessageContent()`
 * @return {!Uint8Array}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getMessageContent_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getMessageContent());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setMessageContent = function(value) {
    return jspb.Message.setProto3BytesField(this, 9, value);
};
/**
 * optional uint32 unread_user_id = 10;
 * @return {number}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getUnreadUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setUnreadUserId = function(value) {
    return jspb.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.clearUnreadUserId = function() {
    return jspb.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.hasUnreadUserId = function() {
    return jspb.Message.getField(this, 10) != null;
};
/**
 * optional uint64 created_at_ms = 11;
 * @return {number}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getCreatedAtMs = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setCreatedAtMs = function(value) {
    return jspb.Message.setProto3IntField(this, 11, value);
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
/**
 * optional uint32 group_id = 21;
 * @return {number}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.getGroupId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 21, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.setGroupId = function(value) {
    return jspb.Message.setField(this, 21, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Call.IMCallProjectionRsp} returns this
 */ proto.IM.Call.IMCallProjectionRsp.prototype.clearGroupId = function() {
    return jspb.Message.setField(this, 21, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Call.IMCallProjectionRsp.prototype.hasGroupId = function() {
    return jspb.Message.getField(this, 21) != null;
};
/**
 * @enum {number}
 */ proto.IM.Call.CallScope = {
    CALL_SCOPE_UNSPECIFIED: 0,
    CALL_SCOPE_DIRECT: 1,
    CALL_SCOPE_GROUP: 2
};
/**
 * @enum {number}
 */ proto.IM.Call.CallMediaKind = {
    CALL_MEDIA_KIND_UNSPECIFIED: 0,
    CALL_MEDIA_KIND_AUDIO: 1,
    CALL_MEDIA_KIND_VIDEO: 2
};
/**
 * @enum {number}
 */ proto.IM.Call.CallLifecycleState = {
    CALL_LIFECYCLE_STATE_UNSPECIFIED: 0,
    CALL_LIFECYCLE_STATE_CREATED: 1,
    CALL_LIFECYCLE_STATE_RINGING: 2,
    CALL_LIFECYCLE_STATE_ANSWERED: 3,
    CALL_LIFECYCLE_STATE_CONNECTING: 4,
    CALL_LIFECYCLE_STATE_CONNECTED: 5,
    CALL_LIFECYCLE_STATE_TERMINAL: 6,
    CALL_LIFECYCLE_STATE_OPEN: 7,
    CALL_LIFECYCLE_STATE_ACTIVE: 8,
    CALL_LIFECYCLE_STATE_ENDING: 9
};
/**
 * @enum {number}
 */ proto.IM.Call.CallTerminalOutcome = {
    CALL_TERMINAL_OUTCOME_UNSPECIFIED: 0,
    CALL_TERMINAL_OUTCOME_COMPLETED: 1,
    CALL_TERMINAL_OUTCOME_DECLINED: 2,
    CALL_TERMINAL_OUTCOME_CANCELLED: 3,
    CALL_TERMINAL_OUTCOME_MISSED: 4,
    CALL_TERMINAL_OUTCOME_BUSY: 5,
    CALL_TERMINAL_OUTCOME_FAILED: 6,
    CALL_TERMINAL_OUTCOME_DISCONNECTED: 7
};
/**
 * @enum {number}
 */ proto.IM.Call.CallParticipantRole = {
    CALL_PARTICIPANT_ROLE_UNSPECIFIED: 0,
    CALL_PARTICIPANT_ROLE_INITIATOR: 1,
    CALL_PARTICIPANT_ROLE_INVITEE: 2,
    CALL_PARTICIPANT_ROLE_HOST: 3,
    CALL_PARTICIPANT_ROLE_MEMBER: 4
};
/**
 * @enum {number}
 */ proto.IM.Call.CallParticipantOutcome = {
    CALL_PARTICIPANT_OUTCOME_UNSPECIFIED: 0,
    CALL_PARTICIPANT_OUTCOME_INVITED: 1,
    CALL_PARTICIPANT_OUTCOME_PARTICIPATED: 2,
    CALL_PARTICIPANT_OUTCOME_DECLINED: 3,
    CALL_PARTICIPANT_OUTCOME_MISSED: 4,
    CALL_PARTICIPANT_OUTCOME_REMOVED: 5
};
/**
 * @enum {number}
 */ proto.IM.Call.CallCommandType = {
    CALL_COMMAND_TYPE_UNSPECIFIED: 0,
    CALL_COMMAND_TYPE_CREATE: 1,
    CALL_COMMAND_TYPE_ANSWER: 2,
    CALL_COMMAND_TYPE_DECLINE: 3,
    CALL_COMMAND_TYPE_CANCEL: 4,
    CALL_COMMAND_TYPE_HANGUP: 5,
    CALL_COMMAND_TYPE_QUERY: 6,
    CALL_COMMAND_TYPE_HOST_END: 7,
    CALL_COMMAND_TYPE_REMOVE_PARTICIPANT: 8,
    CALL_COMMAND_TYPE_GROUP_JOIN: 9,
    CALL_COMMAND_TYPE_GROUP_LEAVE: 10,
    CALL_COMMAND_TYPE_GROUP_SWITCH_DEVICE: 11
};
/**
 * @enum {number}
 */ proto.IM.Call.CallResultCode = {
    CALL_RESULT_CODE_UNSPECIFIED: 0,
    CALL_RESULT_CODE_COMMITTED: 1,
    CALL_RESULT_CODE_ALREADY_COMMITTED: 2,
    CALL_RESULT_CODE_CONFLICT: 3,
    CALL_RESULT_CODE_INVALID_ACTOR: 4,
    CALL_RESULT_CODE_STALE_FENCE: 5,
    CALL_RESULT_CODE_BUSY: 6,
    CALL_RESULT_CODE_TERMINAL: 7,
    CALL_RESULT_CODE_UNAVAILABLE: 8,
    CALL_RESULT_CODE_TIMEOUT: 9
};
/**
 * @enum {number}
 */ proto.IM.Call.CallSignalingOperation = {
    CALL_SIGNALING_OPERATION_UNSPECIFIED: 0,
    CALL_SIGNALING_OPERATION_OFFER: 1,
    CALL_SIGNALING_OPERATION_ANSWER: 2,
    CALL_SIGNALING_OPERATION_ICE: 3
};
/**
 * @enum {number}
 */ proto.IM.Call.CallParticipantReportType = {
    CALL_PARTICIPANT_REPORT_TYPE_UNSPECIFIED: 0,
    CALL_PARTICIPANT_REPORT_TYPE_MEDIA_CONNECTED: 1,
    CALL_PARTICIPANT_REPORT_TYPE_LEASE_REFRESH: 2,
    CALL_PARTICIPANT_REPORT_TYPE_GROUP_MEDIA_ACTIVE: 3,
    CALL_PARTICIPANT_REPORT_TYPE_GROUP_LEAVE: 4
};
/**
 * @enum {number}
 */ proto.IM.Call.CallProjectionKind = {
    CALL_PROJECTION_KIND_UNSPECIFIED: 0,
    CALL_PROJECTION_KIND_DIRECT_MESSAGE: 1,
    CALL_PROJECTION_KIND_GROUP_MESSAGE: 2
};
/**
 * @enum {number}
 */ proto.IM.Call.GroupAttendanceLegStatus = {
    GROUP_ATTENDANCE_LEG_STATUS_UNSPECIFIED: 0,
    GROUP_ATTENDANCE_LEG_STATUS_OBSERVING: 1,
    GROUP_ATTENDANCE_LEG_STATUS_MEDIA_ACTIVE: 2,
    GROUP_ATTENDANCE_LEG_STATUS_LEFT: 3,
    GROUP_ATTENDANCE_LEG_STATUS_REVOKED: 4
};
/**
 * @enum {number}
 */ proto.IM.Call.CallProviderEventType = {
    CALL_PROVIDER_EVENT_TYPE_UNSPECIFIED: 0,
    CALL_PROVIDER_EVENT_TYPE_PARTICIPANT_JOINED: 1,
    CALL_PROVIDER_EVENT_TYPE_PARTICIPANT_LEFT: 2,
    CALL_PROVIDER_EVENT_TYPE_ROOM_FINISHED: 3
};
goog.object.extend(exports, proto.IM.Call);

})();

export default module.exports;
